export default {
  ActionConfirm: "Harakatni tasdiqlang",
  ActivatePromocode: "Promo-kodni faollashtiring",
  AddFile: "Fayl qo'shish\n",
  AddToFavorites: "Tanlanganlarga qo'shish",
  "Andar Bahar": "Andar Bahar",
  ApplyFilter: "Filtrni qo'llash",
  AppsPage: {
    blocks: {
      descriptionOne: "Dolzarb oynalarni izlashning hojati yo'q",
      descriptionThree: "Barcha aksiyalar, turnirlar va o'yinlar haqida shaxsiy bildirishnomalar",
      descriptionTwo: "Ilova foydalanuvchilari uchun noyob aksiyalar va takliflar",
      titleOne: "OLYMP har doim qo'lingizda",
      titleThree: "Barcha tadbirlar va takliflardan xabardor bo'ling",
      titleTwo: "Eksklyuziv aksiyalar va turnirlar"
    },
    dontWorry: "Xavotir olmang, bu xavfsiz",
    howToInstall: "Qanday o'rnatish kerak",
    installAndroid: "Android uchun yuklab olish",
    installIos: "IOS uchun o'rnatish",
    installIsSafe: "Xavfsiz o'rnatish ",
    qrText: "Ilovani yuklab olish uchun kamerangizni QR kodga qarating",
    safeDescription: "Google-ning qimor oʻyinlari siyosati tufayli biz ilovani Play Marketga chiqara olmaymiz. O'rnatish uchun ko'rsatmalarga amal qiling",
    seo: {
      all: {
        block_one: {
          description: "{platform} — bu o'yin-kulgining katta assortimentiga ega zamonaviy virtual betting va gembling platformasi. Biz foydalanuvchilarning qulayligiga alohida e'tibor qaratamiz, shuning uchun bizning onlayn saytimizga har qanday qurilmadan —kompyuterdan ham, smartfondan ham tashrif buyurish mumkin. Olymp mobil ilovasi mashhur operatsion tizimlar — Android va iOS asosida ishlaydigan barcha zamonaviy telefonlar uchun moslashtirilgan. Qimor ishqibozlari o'zlari uchun qulay bo'lgan har qanday joyda Internet platformasining barcha imkoniyatlaridan foydalanishlari mumkin.",
          title: "{platform} mobil ilovasi"
        },
        block_three: {
          description: "Ilovani yuklab olgan va ro'yxatdan o'tgan har qanday o'yinchining ixtiyorida — saytning barcha funktsiyalari va to'liq vositalar to'plami. Mobil ilovada aniq nima mavjud? Shaxsiy akkauntingiz orqali siz quyidagilarni qilishingiz mumkin:",
          list: {
            five: "O'yin hisobvarag'idagi moliyaviy operatsiyalar tarixini o'rganish-pul olish buyurtmalari, to'lovlar va stavkalar.",
            four: "Bonuslardan foydalaning — welcome-paket va boshqa sovg'alar.",
            one: "Profilni o'rnating — telefon raqami yoki elektron pochta manzilini qo'shing, o'zingiz haqingizda ma'lumotlarni to'ldiring va uni o'zgartiring.",
            three: "Xabarlarda kazino xabarnomalarini kuzatib boring.",
            two: "Balansni tekshiring, uni har qanday qulay usul bilan to'ldiring, mukofot summalarini oling va bir zumda keshbek oling."
          },
          text: "Siz ro'yxatdan o'tish jarayonidan so'ng darhol Olymp kazinosida onlayn o'ynashingiz va pul tikishingiz mumkin. Siz faqat minimal depozit qo'yishingiz va o'zingizning xohishingizga ko'ra o'yin — kulgini tanlashingiz kerak-bizning dasturimizda o'yin avtomatlari, lotereyalar, tezkor, sport va klassik o'yinlar, live kazinolar, sport tikish va turli turnirlar mavjud. Agar Olymp Casino ilovasida onlayn sessiya davomida savollaringiz bo'lsa, texnik yordam yordamga keladi. Suhbatni ochish va xabarni maxsus shaklda qoldirish kifoya.",
          title: "Funktsional"
        },
        block_two: {
          description: "Ilova do'konlari — Google Play Market, AppGallery va boshqa marketlar — qimor o'yinlari bo'yicha turli xil siyosatlarga ega va har doim ham o'z kataloglarida kerakli dasturlarni joylashtirmaydi. Biz sizga qidiruv jarayonini soddalashtirdik va mobil ilovani joylashtirdik Olymp hamma uchun ochiq operatsion tizim — uni to'g'ridan-to'g'ri rasmiy veb-saytimizdan yuklab olish oson. Siz quyidagi harakat algoritmlaridan birini tanlashingiz mumkin:",
          list: {
            one: "Kompyuterdan foydalaning. Buning uchun har qanday brauzer orqali rasmiy {platform} portalini ishga tushiring yoki qidiruv tizimi orqali ishlaydigan Oynani oching. U erda siz \"iOS uchun o'rnatish\" va \"Android uchun yuklab olish\"tugmachalari bo'lgan sahifani topasiz. Tegishli variantni bosing va telefon kamerasi yordamida QR kodini skanerlang. Uning ekranida havola ko'rsatiladi-unga o'ting. Agar siz iPhone — dan foydalanayotgan bo'lsangiz, uni yuklab olishingiz mumkin bo'lgan App Store-dagi ilovamizga yo'naltirilasiz. Agar sizda Android bo'lsa, dasturni o'rnatishga ruxsat berishingiz va uning tugashini kutishingiz kerak.",
            two: "Mobil qurilmalardan foydalaning. {platformSite} saytiga o‘ting — Olymp veb-saytining mobil versiyasi ochiladi. Iovani bepul yuklab olish uchun avval smartfoningizning OT-ga qarab yuklab olish uchun ikkita tugmachani tanlang. Avval telefonning \"sozlamalari\" ga qarashni va noma'lum fayllarni o'rnatishga ruxsat berishni unutmang — bu xavfsiz. Ilova bir necha daqiqada yuklab olinadi"
          },
          text: "\"Kirish\" tugmasini bosing va avtorizatsiya qilishni boshlang. Agar siz hali {platform} akkauntini ochmagan  bo'lsangiz, buni qilish vaqti keldi. Tegishli maydonlarga telefon raqamini yoki e-mail  kiriting, yaxshi parol bilan  va amalni tasdiqlang.",
          title: "Ilovani qaerdan yuklab olish mumkin"
        }
      },
      android: {
        block_four: {
          description: "{platform} mobil ilovasi ingliz, qozoq, o'zbek, qirg'iz va rus tillarida ishlaydi — uni istalgan vaqtda o'zgartirishingiz mumkin. Ilova telefon orqali maksimal qulaylik bilan foydalanishga moslashtirilgan-interfeysning barcha elementlari mobil ekranlarning o'lchamlarini hisobga olgan holda bu erga ko'chirilgan. Har bir vakolatli smartfon egasi saytning ish stoli versiyasining barcha funktsiyalariga ega:",
          list: {
            five: "Shaxsiy xabarlar.",
            four: "To'lovlar, stavkalar va yechish buyurtmalari tarixi.",
            one: "Profil sozlamalari.",
            three: "Promokodlar va sovg'alar — frispinlar, bepul garovlar va depozit bonuslari.",
            two: "O'yin hisobi bilan operatsiyalar — to'ldirish, yechish va tezkor keshbek."
          },
          text: "Va eng muhimi — telefon yoki planshet orqali siz o'zingizni qiziqtirgan har qanday o'yinlarni sinab ko'rishingiz, sport garovlarida omadingizni sinab ko'rishingiz va aktsiyalar va turnirlarda ishtirok etishingiz mumkin. Olymp Kazino har doim sizning qo'lingizda bo'ladi va shaxsiy bildirishnomalar tufayli siz eksklyuziv takliflarni o'tkazib yubormaysiz.",
          title: "Funktsional"
        },
        block_one: {
          description: "{platform}-da joylashgan joyidan qat'i nazar, zavq bilan dam olishni afzal ko'rgan har bir kishi uchun qimor o'yinlarining boy to'plami mavjud. Garovlar sportga va lotereyalar, tezkor va bet o'yinlari, live-kazino va slotlar-o'yin dasturlari siz uchun to'g'ridan-to'g'ri telefondan mavjud! Android operatsion tizimiga asoslangan smartfonlar egalari hamma narsani sotib olishlari mumkin — ayniqsa siz uchun biz Android uchun maxsus Olymp mobil ilovasini ishlab chiqdik. Shaxsiy hisobingizni telefon yoki planshet orqali to'ldiring, sevimli o'yin mashinalari va uyalarini onlayn ishga tushiring va jarayondan zavqlaning.",
          title: "Android uchun ilova Olymp Kazino"
        },
        block_three: {
          description: "Rasmiy veb-saytdan Android-da Olymp dasturini bepul yuklab olmoqchimisiz? APK fayllarini o'rnatish uchun mobil qurilmani tayyorlashingiz kerak. Boshlash uchun kerakli ruxsatlarni yoqing:",
          list: {
            four: "Ekranda \"Ushbu manbadan o'rnatishga ruxsat berish\" so'rovi paydo bo'lganda, yuklab olishni boshlash uchun tugmani bosing.",
            one: "Smartfoningizdagi \"Sozlamalar\" ga o'ting va \"ilovalar\"bandini toping.",
            three: "Noma'lum ilovalarni o'rnatishga ruxsat bering.",
            two: "\"Ruxsatnomalar\" menyusini oching."
          },
          text: "QR-kod yordamida Olymp dasturini Android-ga portalning ish stoli versiyasi orqali yuklab olishingiz mumkin. U to'g'ridan — to'g'ri sahifada paydo bo'ladi-siz faqat smartfon kamerasini kodga yo'naltirishingiz va yuklab olish havolasini kutishingiz kerak. Olymp Casino-ning mobil versiyasi bilan o'rnatish jarayoni bir nechta oddiy harakatlarga to'g'ri keladi. Ilovani smartfon orqali yuklab olish uchun portalning mobil versiyasini brauzeringizda oching. U erda siz \"ilovani yuklab olish\"tugmachasini ko'rasiz. Unga o'ting-va sizning oldingizda \"yuklab olish\"yozuvi paydo bo'ladi. O'rnatish havolalarini bosishdan qo'rqmang-bu xavfsiz, fayl ishonchli manbadan yuklab olinadi. Tayyor! Mobil ilovaning barcha afzalliklaridan bahramand bo'lish mumkin. Endi siz ishlaydigan nometalllarni qidirish yoki VPN-ni o'rnatish muammosidan xalos bo'ldingiz-internetga ulanganingizda Olymp Casino mobil ilovasi ishlaydi. Agar ushbu dastur so'nggi versiyaga yangilanishni talab qilsa, hamma narsa to'g'ri ishlashi uchun buni bajaring.",
          title: "O'rnatish bo'yicha ko'rsatmalar"
        },
        block_two: {
          description: "Android uchun {platform} mobil ilovasi eng yaxshi qimor o'yinlari va sport tikish dunyosiga yo'lboshchingizdir. Uni qaerdan yuklab olish mumkin? Android uchun mobil bozorlarda-masalan, Google Play Market, AppGallery yoki boshqa shunga o'xshash ilovalar do'konida — qimor o'yinlari bo'yicha maxsus siyosat mavjud. U erda siz faqat uchinchi tomon ishlab chiquvchilarining loyihalarini topishingiz mumkin. Ular Olymp Casino rasmiy sayti bilan hech qanday aloqasi yo'q. Asl dasturimizni topish uchun siz asosiy olymp.casino saytini ochishingiz kerak kompyuterda yoki mobil qurilmada.",
          title: "Ilovani qaerdan yuklab olish mumkin"
        }
      },
      ios: {
        block_one: {
          description: "IPhone va iPad egalari orasida {platform} qimor o'yinlarining ko'plab muxlislari bor. iOS operatsion tizimiga asoslangan qurilmalar uchun mobil ilovamiz foydalanuvchilarga keng imkoniyatlarni ochib beradi va to'liq harakat erkinligini ta'minlaydi. Istalgan vaqtda cho'ntagingizda-to'liq onlayn kazino funksiyasiga ega ulkan ko'ngilochar katalog. Hisob raqamiga mablag ' kiriting, Profil ma'lumotlarini boshqaring, har qanday o'lchamdagi mukofot summalarini naqd qiling, onlayn o'ynang va har kuni yangisini sinab ko'ring. IOS uchun Olymp kazino mobil ilovasi sizga o'zingiz xohlagancha zavq va foyda olishga yordam beradi! Buning uchun siz telefoningizni yoki planshetingizni to'g'ri \"jihozlashingiz\" va o'yin-kulgiga o'tishingiz kerak.",
          title: "iPhone uchun iOS Olymp Casino ilovasi"
        },
        block_three: {
          description: "iOS-ga asoslangan qurilmalar uchun Olymp  ilovasi sizga platformaning barcha qimor o'yinlari to'plamiga — ko'plab uyalar, stol, sport va avariya o'yinlariga, stollarga, lotereyalarga, aktsiyalarga, turnirlarga to'liq kirish huquqini beradi. Mobil ilovadagi shaxsiy hisob qaydnomangiz orqali har qanday kerakli amallarni bajarishingiz mumkin:",
          list: {
            five: "Operatsiyalar tarixini ko'ring — pul, tranzaktsiyalar va tariflarni yechib olish bo'yicha barcha buyurtmalar.",
            four: "Kazinodan kelgan xabarlarni o'qing.",
            one: "Profildagi shaxsiy ma'lumotlarni o'zgartiring va tekshiruvdan o'ting.",
            three: "Sovg'alarni oling, faollashtiring va tikish — yangi kelganlar uchun welcome bonusi.",
            two: "Hisobingizni to'ldiring, yutuqlaringizni naqd qiling va darhol keshbek oling."
          },
          text: "Ayniqsa, mobil ilova foydalanuvchilari uchun juda ko'p noyob takliflar mavjud: barcha voqealardan xabardor bo'lish va foydali aktsiyalar, joriy lotereyalar va eksklyuziv turnirlar haqida o'z vaqtida bilib olish uchun bildirishnomalarni yoqishni unutmang. Depozitni to'ldirish, pul tikish, o'yin mashinalarini \"sinab ko'rish\" va omadni pompalash vaqti keldi. Olymp kazino ilovasidagi har bir virtual sessiya sizga faqat yoqimli tajriba taqdim etishiga ishonch hosil qildik.",
          title: "Funktsionallik va imkoniyatlar"
        },
        block_two: {
          description: "Biz foydalanuvchilar uchun ularni o'yin uchun zarur vosita bilan qanday qilib samarali va qulay tarzda ta'minlashni bilamiz. Apple kompaniyasining do'konida {platform} mobil ilovasi mavjud-bu bepul. iOS uchun rasmiy Olymp dasturini yuklab olish uchun uni App Store-dan yuklab olish uchun havolani olishingiz kerak. Buning ikkita usuli bor-siz qulayroq birini tanlashingiz mumkin:",
          list: {
            one: "Kompyuteringizda rasmiy Olymp veb-saytini ishga tushiring va mobil ilovaga havola qilingan sahifaga o'ting. U erda siz QR kodini ko'rasiz-qurilmangiz kamerasini unga yo'naltiring va yuklab olish havolasini bosing.",
            two: "Portalga o'ting {platformSite} darhol iOS platformasidagi qurilma orqali-mobil versiya ochiladi. Olymp dasturini iPhone yoki iPad-ga shu tarzda yuklab olish uchun \"iOS uchun o'rnatish\"tugmasini bosing. Siz App Store — ga yo'naltirilasiz-va dasturni o'rnatishni boshlashingiz mumkin."
          },
          text: "Yuklab olish tugagach, siz tizimda akkaunt sistemasini yaratishingiz yoki shaxsiy hisobingiz bo'lsa, tizimga kirishingiz va eng qiziqarli — {platform} o'yin-kulgilarini boshlashingiz mumkin!",
          title: "Ilovani o'rnatish oson"
        }
      }
    },
    seoText: "Ayfonlar uchun sahifada maxsus seosh matni kerak bo'lmasligi mumkin, ammo siz sinab ko'rishingiz mumkin ilovaga sharh yozing va \"olimpbet ilovani ko'rib chiqish\" deb nomlangan toifasining semantikasi uchun optimallashtiring. U yerda ham bu yerda ham deyarli chastota yo'q.",
    seoTitle: "SEO matni",
    slider: {
      textEight: "Saytdagi \"Ilovani yuklab olish\" tugmasini bosing",
      textFive: "\"O'rnatish\" tugmasini bosing",
      textFour: "Yuklab olingan dastur fayliga bosing",
      textOne: "Yuklab olishni boshlash uchun \"Yuklash\" tugmasini bosing",
      textSeven: "Telefon kamerangizni QR kodiga qarating va saytga o'ting",
      textSix: "Ilovani ish stolidan ishga tushiring va o'ynang",
      textThree: "Noma'lum manbalardan ilovalarni o'rnatishga ruxsat bering",
      textTwo: "\"Noma'lum ilovalarni o'rnatish\" bo'limiga o'ting"
    },
    slides: {
      allowInstall: "Noma'lum manbalardan o'rnatishga ruxsat bering",
      cancel: "Bekor qilish",
      download: "Yuklash",
      downloadApp: "Ilovani yuklab olish",
      downloadIsDone: "Yuklash yakunlandi",
      installUnknownApp: "Noma'lum ilovalarni o'rnatish",
      isntall: "O'rnatish",
      moveToSite: "Saytga o'tish",
      myFiles: "Mening fayllarim",
      safeDescription: "Play Marketdan ilovalarni o'rnatish emas. Faylni faqat ishonchli manbadan yuklab oling",
      settings: "Sozlamalar"
    },
    textForMobile: {
      androidAndIos: "Android va IOS uchun",
      downloadOnAndroid: "Andoid uchun yuklab uchun",
      downloadOnAndroidAndIos: "Android va IOS uchun yuklab uchun",
      downloadOnIos: "IOS uchun yuklab uchun",
      onAndroid: "Android uchun",
      onIos: "IOS uchun"
    },
    title: "Olymp ilovasi"
  },
  Aviator: "Aviator",
  Basket: "Savat",
  BeforeEndPromotion: "Aksiya tugashigacham",
  BeforeStartPromotion: "Aksiya boshlanishidan oldin",
  Betgames: "Betgames",
  Bets: "Garovlar",
  BonusBalanceOff: "Siz asosiy kazino balansiga o'tdingiz. Hisobingizni moliyalashtiring va sevimli o'yinlaringizni o'ynang.",
  BonusBalanceOn: "Siz bonus balansiga o'tdingiz.",
  BonusesAndPromotions: "Bonuslar va aktsiyalar",
  BonusesAndPromotionsSection: "Bonuslar va aktsiyalar bo'limi",
  Categories: "Kategoriyalar",
  Chat: "Suhbat",
  CloseMatchTracker: "Match kuzatuvchisini yopish",
  CoefficientChanged: "Koeffitsient o'zgargan",
  ContactSupport: "Qo'llab-quvvatlash uchun murojaat qiling",
  "Cricket X": "Kriket X",
  DeleteConfirm: "O'chirishni tasdiqlash",
  DeleteConfirmText: "Siz haqiqatan ham ilgari yuklab olingan fayllarni o'chirishni xohlaysizmi?",
  DeleteFiles: "Fayllarni o'chirish",
  DenyReason: "Sabablarga ko'ra rad etildi",
  DocumentAlreadyAttached: "Bu fayl allaqachon biriktirilgan",
  DocumentDoesntMeetRequirements: "Hujjat talablarga javob bermaydi",
  DocumentResolutionTooBig: "Surat ruxsati hajmi yuqori. Maksimal ruxsat etilgan - {value} Mp",
  DocumentsFilesLimits: "(maks. fayllar soni - {fields}, maks. fayl hajmi - {size} Mb)",
  DocumentsUploadError: "Fayllarni yuklab olishda xatolik yuz berdi - {files}. Qolgan fayllar tekshirishga yuborildi. Fayllarni qayta yuklashga urinib ko'rishingiz mumkin.",
  DownloadOn: "Yuklab olish",
  EuroLanding: {
    activate: "\"Bonuslar\" bo'limida <br /><span>faollashtiring</span>",
    bonusText: "<span>Ro'yhatdan o'tganingiz uchun</span><b>{freebet}</b><span>fribet!</span>",
    register: "Olymp Casino saytida <br /><span>ro'yhatdan o'ting</span>"
  },
  Event: "Hodisa",
  Exclusive: "Exclusive",
  Expires: "Muddati tugayapti",
  ForbidenBonus: "Ushbu kun sovrini allaqachon olingan",
  Found: "Topildi",
  FruityWheel: {
    btn: "Aylantir",
    title: "Aylantiring va welcome bonusingizni bilib oling\n"
  },
  GatesOfOlympus: {
    completeSignIn: "Ro'yxatdan o'tishni hozir yakunlang va bonus oling\n",
    getBonus: "Bonusni oling\n",
    spin: "Aylantiring",
    titleFirstLine: "G'ildirakni aylantiring",
    titleSecondLine: "bonuslar oling",
    twist: "Aylantirish\n",
    youWin: "Siz yutdingiz\n",
    yourBonus: "Sizning bonusingiz"
  },
  GetYourPrizes: "Sovrinlarni olib keting",
  GoldenTimesKz: {
    bonusText: "Tabriklaymiz! Sizning yutuqlaringiz",
    headTitle: "Bonusingizni oling <br /> va jekpotni oling!",
    labelText: "Telefon raqamingizni kiriting"
  },
  InformationAllPromotions: "Hamma chegirmalar haqida ma’lumotlar",
  InitialCoefficient: "Asl koef.:",
  JetX: "JetX",
  LongTermRates: "Uzoq muddatli garovlar",
  MainSite: "Asosiy sahifa",
  MatchTracker: "Match kuzatuvchisi\n\n",
  MaximizeMatchTracker: "Match kuzatuvchisini kattalashtirish",
  MinimizeMatchTracker: "Match kuzatuvchisini kamaytirish",
  Mobile: "Mobil",
  MobileAppSetupLanding: {
    app: "/app",
    appText: "/app ni menyu bandidan tanlang",
    getLink: "yoki Telegram botda havola oling\n\n",
    getLinkButton: "Havola olish",
    groups: {
      four: "Xabardor bo'ling hamma <br/>voqea va takliflardan\n\n",
      one: "<span>Depozitsiz 100 FS</span>ilovani o’rnatganingiz uchun",
      three: "Eksklyuziv <br/>aksiyalar va turnirlar",
      two: "Qidirish kerak emas <br/>joriy oynalar"
    },
    start: "/start",
    startText: "/start tugmasini bosish orqali Telegram botni ishga tushiring",
    successLink: "Havola muvaffaqiyatli yuborildi",
    text: "Olymp mobil ilovasini yuklab oling va istalgan vaqtda oʻynashga tayyor turing",
    title: "<span>100 FS <br/>depozitsiz </span>OLYMP o’rnatganingiz uchun\n\n"
  },
  MobileApplications: "Mobil ilovalar",
  MyDocuments: "Mening hujjatlarim",
  NewYearRules: {
    "1": "Aktsiya o'tiladigan payt: 20.12.2024 00:00 - 02.01.2025 23:59:59 GTM +5",
    "10": "Aviatorda bepul tikish",
    "11": "JetXda bepul tikish",
    "12": "Agar siz promo-sahifada bonus yutgan bo'lsangiz, bonus \"Bonusga o'tish\" tugmasini bosish orqali shaxsiy hisobingizning \"Bonuslar\" bo'limiga qo'shiladi",
    "13": "Qo'shilgan bonuslarni 3 kun ichida faollashtirish mumkin",
    "14": "Faollashtirilgandan so'ng, depozitni 1 kun ichida to'ldirish kerak",
    "15": "Bonus mablag'larini tikish 1 kun ichida yakunlanishi kerak",
    "16": "Har bir bonus uchun batafsil shartlar shaxsiy hisobingizdagi \"Bonuslar\" sahifasida mavjud",
    "2": "Har kuni promo-sahifada sizga bonus olish uchun 3 marta urinish beriladi",
    "3": "Urinishlar soni 3 gacha qisqaradi aktsiya paytida har kuni soat 00:00 GTM +5",
    "4": "Bonusni yutib olish uchun foydalanuvchi har kuni promo-sahifaga o‘tishi va SPIN tugmasini bosish orqali o‘yin mashinasini ishga tushirishi kerak",
    "5": "SPIN tugmachasini har bir bosish bitta urinish oladi",
    "6": "Bonus yutug'i va bonus turi tasodifiy tarzda aniqlanadi:",
    "7": "Slot depozit bonusi",
    "8": "Slotlarda bepul aylanishlar",
    "9": "Sport uchun bepul tikish"
  },
  NezlobLanding: {
    forDeposit: "depozitga",
    title: "Hazillar tugadi!"
  },
  NotCalculated: "Hisoblanmagan",
  NotSingleActionCurrentlyHeld: "Hozirda hech qanday aksiya o'tkazilmayapti",
  OlimpCasino: "Olimp kazino",
  OpenFullVersion: "To'liq versiyani ochish",
  PaymentMethods: "To’lov usullari",
  PlayEveryDay: "Har kuni o'ynang",
  PromoAvailableFrom: "Aksiya {date} yildan beri mavjud",
  PromoAvailableFromTo: "Aksiya {date1} dan {date2} -yilgacha mavjud",
  PromoEnded: "Aksiya {date} yilda yakunlandi",
  Promotions: "Aksiya",
  PromotionsWillDisplayedHere: "Bu erda aksiyalar ko'rsatiladi",
  QuestionAndAnswer: "Savol - Javob",
  RulesAcceptingBets: "«Olimp» bukmekerlik idorasi garovlarini qabul qilish qoidalari",
  RulesOfPromotion: "Aksiya qoidalari",
  RulesSingle: "Qoidalar",
  SelectTypeSystem: "Tizim turini tanlang",
  Soon: "Tez orada",
  Statistics: "Statistika",
  StayTuned: "Biz bilan qoling",
  TableContents: "Mundarija",
  TheSearchHasNotGivenAnyResults: "Qidiruv hech qanday natija bermadi",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "O'chirish uchun siz telefon va elektron pochtangizni tasdiqlashingiz kerak",
  ToMain: "Asosiy",
  ToUp: "Tepaga",
  TypeBonusesAndPromotions: "Bonuslar va aktsiyalar turlari",
  UntilTheNextBonus: "Keyingi bonusgacha",
  UploadDocuments: "Yuklangan fayllar",
  Version: "versiya",
  WeAreOnSocialMedia: "Biz ijtimoiy tarmoqlardarmiz",
  WeOnSocialMediaFull: "Biz ijtimoiy tarmoqlardarmiz",
  WorldCup: "Jahon chempionati-2022",
  YouDataProtected: "Shaxsiy ma'lumotlar va mablag'lar xavfsizlashtirildi",
  YourBonus: "Sizning bonusingiz",
  aboutBonus: "Bonus haqida ko'proq ma'lumot",
  acceptWithModifiedOdds: "O'zgartirilgan koeffitsientlar bilan qabul qiling",
  acceptWithModifiedTotals: "O'zgartirilgan total / foralar bilan qabul qiling",
  accountApprove: "Akkaunt himoyalangan",
  accountNotApprove: "Akkaunt tasdiqlanmagan",
  action: "Harakat",
  activate: "Faollashtirish",
  activateBonus: "Bonusni faollashtiring",
  activateFastBets: "Tezkor tikishlarni faollashtiring\n",
  activatingPromoCode: "Promo-kodni faollashtirish",
  active: "Faol",
  activeBonusErr: "Bonusni aktivlashtirish uchun kamida quyidagi miqdorda depozit qo'yish qolgan",
  activeWager: "Faol stavka",
  add: "Qo'shish",
  addToBasket: "Savatga qo'shish",
  addYourFavoriteGames: "Sevimli o'yinlaringizni sevimlilaringizga qo'shing",
  addingDogeCoin: "Doge tangasini qo'shish",
  additionalInfo: "Qo'shimcha ma'lumot",
  addressCryptoWallet: "Kripto hamyon manzili",
  addressWallet: "Hamyon manzili",
  afterInstallApp: "Ilovani o'rnatganingiz uchun sizga {0} bonus berildi",
  agreeTermsAndConditions: "Men {0} bilan roziman va 18 yoshdan oshganimni tasdiqlayman",
  all: "Hammasi",
  allDepositMethods: "Barcha to'ldirish usullari\n",
  allGames: "Barcha o’yinlar",
  allMessages: "Jami",
  allMessagesButton: "Xabarlarga o'tinsh",
  allMessagesText: "Barcha xabarlar",
  allPromo: "Barcha aktsiyalar",
  allRequiredFieldsMustBeFilled: "Barcha kerakli maydonlar to'ldirilishi kerak",
  allTypes: "Barcha turlari",
  allWithdrawMethods: "Barcha pul yechish usullari\n",
  all_right: "Barcha huquqlar himoyalangan.",
  alreadyHasAccount: "Hisob bor",
  always: "Har doim",
  amountOnAccount: "Hisobdagi miqdor",
  anUnexpectedErrorOccurred: "Kutilmagan xatolik yuz berdi!",
  antifraud: {
    five: "Ko'p bosqichli mijozlar tekshiruvi( ip orqali tekshirish ,tizim parametrlarini olib tashlash, proksi tekshiruvi); mijozning telefon raqamini tekshirish; mutaxassis tomonidan o'yinchi xatti-harakatlarini tahlil qilish; firibgarlikdan himoya qilish tizimi to'lov ma'lumotlarini, to'lov tarixini va foydalanuvchilarning qora ro'yxatini chuqur tekshirish uchun mo'ljallangan 100 dan ortiq filtrga ega; mijoz pul olish bosqichida nazorat xizmatimiz tomonidan yakuniy tekshiruvdan o'tadi",
    four: "Asosiy xususiyatlar",
    one: "Firibgarlikdan himoya qilish",
    three: "Internet to'lovlarining etakchi xizmat ko'rsatuvchi provayderlar bilan hamkorlikda, biz onlayn biznesni ishonchli tarzda amalga oshirish uchun qo'limizdan kelganini ishonchli va foydalanuvchilarimizning shaxsiy ma'lumotlari, shuningdek barcha to'lov ma'lu&\"motlari xavfsizligini kafolatlaymiz. Bizning o'n yillik tajribamiz To'lov operatsiyalari ma'lumotlar bazalarini boshqarish bo'yicha o'n yillik tajribamiz Avento AntiFraud Tool -ni kredit karta firibgarligiga qarshi chindan ham kuchli va qulay vositaga aylantiradi",
    two: "Avento AntiFraud Tool-bu firibgarlikka qarshi kuchli vosita bo'lib, onlayn qimor o'yinlarini qalbakilashtirishning oldini oladi. Bu bizga qimor o'yinlari korxonalarida kredit kartalari bo'yicha firibgarlik sonini sezilarli darajada kamaytirish imkonini beradi."
  },
  app: "Ilova",
  appOlymp: "Olymp ilovasi",
  apply: "Qo'llash",
  approve: "Tasdiqlayman",
  approvePhoneBySms: "SMS orqali raqamni tasdiqlash",
  approvePhoneByTelegram: "Telegram orqali raqamni tasdiqlash",
  approved: "Tasdiqlandi",
  approvedSecond: "Tasdiqlangan",
  approvingWithdraw: "Pul yechishning tasdiqlanishi\n",
  april: "aprel",
  areYouSureDeposit: "Siz aniq to'ldirdingizmi?\n",
  areYouSureToDeclineBonus: "Bonusdan voz kechishni xohlayotganingizga aminmisiz?",
  areYouSureYouWantToSell: "Siz stavkani sotmoqchi ekanligingizga aminsiz\n",
  attach: "Hujjatlarni biriktiring",
  attachDocumentsToVerifyAccount: "Iltimos, tekshirishni yakunlash va pulni yechib olish uchun hujjatlarni  biriktiring",
  attempt: "Urinishlar yo'q | 1 urinish | {count} urinishlar",
  august: "avgust",
  authApproveText: "Parolni o'zgartirgandan so'ng, vaqtinchalik mablag' yechib bo'lmaydi, iltimos, AYA qo'llab-quvvatlash xizmatiga murojaat qiling.",
  authFromSocial: "Ijtimoiy tarmoqlar orqali kirish",
  authorization: "Avtorizatsiya",
  authorizationRequired: "Pulli o'yin avtorizatsiya talab qiladi!",
  availabilityWallet: "Kripto hamyonni kerak {wallet}",
  available: "Mavjud",
  availableBonuses: "Mavjud bonuslar",
  availableOnlyGameForMoney: "Faqat pul uchun o'ynash mumkin",
  back: "Orqaga qaytish",
  backToHome: "Asosiy sahifaga qayting",
  backToLogin: "Avtorizatsiyaga qaytish",
  backToOneStep: "Birinchi bosqichga qaytish",
  balance: "Balans",
  balanceAfterTopUp: "To‘ldirgandan keyingi balans: {value}",
  balanceAfterWithdraw: "Pul yechib olingandan keyingi balans: {value}",
  balanceBK: "Balans",
  balanceBKRefreshSuccessfully: "BK balansi muvaffaqiyatli yangilandi",
  balanceCasino: "Kazino balansi",
  balanceCasinoRefreshSuccessfully: "Balansi muvaffaqiyatli yangilandi",
  balanceSwitchByWithoutBalance: "Bonus balansiga o'tish faqat bonus o'yinlarini o'ynaganda avtomatik ravishda amalga oshiriladi, agar haqiqiy balansda mablag ' bo'lmasa",
  balances: "Balanslar",
  bankCard: "Bank kartasi",
  basketBets: "Savat",
  behind: "uchun",
  bet: "Garov",
  betHistory: "Tikish",
  betID: "Garov ID-si",
  betSoldFor: "Garov {count} ga sotilgan\n",
  betsAreSuspended: "Tikishlarni qabul qilish to'xtatildi\n",
  betsNotAccessForBonusBalance: "Bonus balansidan sport tikish mumkin emas!",
  bettingHistory: {
    bet: "Garov",
    coefficient: "Koeffitsient",
    dataOfBet: "Garov ma'lumotlari",
    findOutTheScore: "Hisobni bilish",
    numberAndDateOfBet: "Raqam va garov sanasi",
    payout: "To'lash",
    status: "Holat"
  },
  bidAddedToCart: "Garov savatga qo'shildi",
  bidDeletedToCart: "Garov savatdan o'chirildi",
  bonus: "Bonus",
  bonusActivated: "Bonus faollashtirilgan",
  bonusActivation: "Bonusni faollashtirish",
  bonusBalance: "Bonus. muvozanat",
  bonusBalanceOnly: "Bonus balansingizdan o'ynash uchun bonus o'yinini boshlang\n",
  bonusCondition: "Bonus shartlari",
  bonusNotActivated: "Bonus faol emas",
  bonusOnFirstDeposit: "Birinchi depozitga 100%<br/>bonus\n",
  bonusQuestion: "Siz hali xush kelibsiz bonusni olmadingizmi?",
  bonusSport: {
    block1: {
      li1: "olymp.casino veb-saytida ro'yxatdan o'ting.",
      li2: "Bonusni faollashtirish uchun Shaxsiy kabinetingizdagi “Bonuslar” bo‘limiga o‘ting va taklifni faollashtiring.",
      li3: "Bitta toʻlovda 500 KZT / 12 000 UZS dan depozit qoʻying.",
      li4: "To'ldirgandan so'ng, bonus avtomatik ravishda hisobga olinadi va kuponingizning \"Sport\" bo'limida tikish uchun mavjud bo'ladi.",
      title: "Bonusni qanday olish mumkin:"
    },
    block2: {
      li1: "Foydalanuvchi faqat bitta bonusga ega.",
      li2: "Bepul tikish faqat sportda ishlatilishi mumkin. Kuponingiz kamida 3 va maksimal 10 koeffitsientga ega bitta garov bo'lishi kerak.",
      li3: "O'yinchi o'z hisobidagi faqat yutuq qismini oladi.",
      text: "Masalan: 3 koeffitsienti uchun 500 bepul garov tikish. O’yinchi o’z hisobiga 3*500-500=1000 oladi.",
      title: "Foydalanish shartlari:"
    },
    block3: {
      li1: "Bepul tikish bo'yicha talablar 7 kun ichida bajarilishi kerak, aks holda bonus muddati tugaydi.",
      li10: "Olymp.casino istalgan vaqtda, oldindan ogohlantirmasdan taklif shartlarini o'zgartirish, bekor qilish yoki yangilash yoki ishtirok etishga bosh tortish huquqiga ega.",
      li11: "Olymp.casino foydalanuvchilarning ushbu yoki boshqa taklifda ishtirok etishini cheklashi yoki rad etishi mumkin.",
      li12: "Har bir mijoz, oila, manzil, umumiy kompyuter, umumiy IP manzil va har qanday bir xil hisob ma'lumotlari, jumladan, elektron pochta manzili, bank hisobi ma'lumotlari, kredit karta ma'lumotlari va to'lov tizimi hisobi ma'lumotlari uchun faqat bitta bonusga ruxsat beriladi. Ushbu bonus taklifidan har qanday suiiste'mol qilish hisobning yopilishiga olib keladi.",
      li13: "Olymp.casino istalgan vaqtda ushbu taklifni o'zgartirish yoki bekor qilish huquqini o'zida saqlab qoladi.",
      li14: "Bonusni qabul qilib, mijoz bonus shartlariga, shuningdek, olymp.casino saytining umumiy qoidalariga rozilik bildiradi.",
      li2: "Yutuqlarni yechib olish uchun , siz minimal depozitni 12 000 UZS va tikish x1 kiritishingiz kerak.",
      li3: "Bekor qilingan yoki qaytarib berilgan taqdirda - garov yo'qotish sifatida hisoblanadi.",
      li4: "Yarmi yutqazgan taqdirda (Osiyo forasi va total) - garov yo'qotish sifatida hisoblanadi.",
      li5: "Yarmi yutgan taqdirda (Osiyo forasi va total) - oddiy garov sifatida hisoblanadi tikish miqdori bundan mustasno.",
      li6: "Garov hisoblangandan so'ng, pul sizning hisobingizga tushadi.",
      li7: "Bepul garovdan qisman foydalanish mumkin emas. (ya'ni, agar sizda 500 bepul garov tikish bo'lsa, siz 500 garov qo'yishingiz kerak. Turli kuponlar uchun 250 - 250 qabul qilinmaydi).",
      li8: "Taklifni boshqa reklama yoki maxsus takliflar bilan birgalikda foydalanish mumkin emas.",
      li9: "Bir nechta hisoblardan foydalanishga yo’l qoyilmaydii va agar bir nechta hisoblar topilsa, bu barcha hisoblarning to'xtatilishiga olib keladi.",
      title: "Boshqa shartlar:"
    },
    title: "Olymp.Casino-ga qo'shilish uchun eng yaxshi vaqt hozir, chunki biz har bir yangi foydalanuvchiga 500 KZT / 12 000 UZS bepul sport garovini taklif qilamiz.\n"
  },
  bonusTimeLeft: "Harakatlarni bajarish vaqti",
  bonusWager: "Bonusli stavka",
  bonuses: "Bonuslar",
  bookmakerShort: "BK",
  "break": "Tanaffus",
  bronze: "Bronza",
  btn: "Kassa",
  byDefault: "Standart miqdor",
  byDefaultDown: "Alifbo tartibida (A-Z)",
  byDefaultUp: "Alifbo tartibida (Z-A)",
  bySport: "Sport turlari bo'yicha",
  cabbage: {
    eight: "- agar o'yinchi 5 kunlik to'liq tsiklni tugatgan bo'lsa.",
    eighteen: "Сыйлық {number}",
    eleven: "Aksiyada ishtirok etsangiz, ushbu aktsiyani amalga oshiruvchi onlayn kazino tomonidan o'rnatilgan ushbu qoidalar va shartlarga avtomatik ravishda rozilik bildirasiz.",
    fifteen: "Мақсаттар мен сыйлықтар",
    five: "Mukofotlar kundalik taraqqiyot va kunlik maqsadlarni amalga oshirish bilan birga o'sib boradi. Kundalik taraqqiyotni davom ettirish, tsiklning keyingi kuniga o'tish va katta mukofotlarga talabgor bo'lish uchun ishtirokchi kamida bir marta kundalik maqsadni bajarishi kerak.",
    four: "\"Kundalik sovrinlar\" kampaniyasi  kundalik maqsadni 3 marta bajarish imkoniyati  bilan. Har biri tsikllarda 5 kalendar kunga qadar davom etadi ",
    fourteen: "Xatoliklar yuz berganda, barcha yutuqlar bekor qilinadi.",
    list: "Qoidalar va shartlar:",
    nine: "Aksiyada ishtirok etish uchun qo'shimcha depozitlar yoki badallar qilish talab qilinmaydi.",
    nineteen: "Күнделікті мақсат 1 рет орындалды",
    one: "Pul ekvivalentida en yuqori navli karam hosilini yig'ish vaqti keldi!",
    seven: "- agar o'yinchi kunni o'tkazib yuborsa yoki kundalik maqsadni kamida bir marta bajarmasa;",
    seventeen: "Күнделікті мақсаттар",
    six: "Ishtirokchining kundalik mukofotlari quiyidagi 2 hollarda birinchi kungacha qaytariladi:",
    sixteen: "Циклдегі күн",
    ten: "Aksiyada ishtirok etish uchun faqat haqiqiy pul uchun o'ynash mumkin.",
    thirteen: "Sayt har qanday vaqtda sovg'alarni to'lamasdan aktsiyani belgisiz vaqtga to'xtatish huquqini saqlab qoladi , shuningdek qoidalarni oldindan ogohlantirmasdan o'zgartirish huquqini qoldiradi.",
    three: "Ishtirok etish uchun Bongo provayderining har qanday o'yinini o'ynashingiz kerak.  Sovrin jamg'armasi-ishtirokchi uchun 1160 evrogacha. Agar ishtirokchi kampaniya davomida (2 to'liq tsikl) barcha mumkin bo'lgan kundalik maqsadlarni bajargan bo'lsa, bu mablag ' maksimal umumiy shaxsiy mukofot jamg'armasi sifatida hisoblanadi. Eng shirin mukofot har bir tsiklning oxirgi kunida bo'ladi!",
    twelve: "Ishtirok etish qoidalari va shartlari istalgan vaqtda faqat saytning ixtiyoriga ko'ra o'zgartirilishi mumkin.",
    twenty: "Күнделікті мақсат 2 рет орындалды",
    twentyFive: "қатысушыға 1160 еуроға дейін!",
    twentyFour: "Жүлде қоры",
    twentyOne: "Күнделікті мақсат 3 рет орындалды",
    twentySix: "Күні мен уақыты",
    two: "Ishtirok etish uchun Booongo provayderining har qanday o'yinini o'ynang va kundalik maqsadlarga erishing. Sovrin jamg'armasi-ishtirokchi uchun 1160 evrogach"
  },
  cabinet: "Shaxsiy kabinet",
  calculated: "Hisoblangan",
  calculationID: "ID hisobi",
  canNotChangeCurrency: "Valyutani o'zgartirish mumkin emas",
  canSelectSavedData: "Saqlangan ma'lumotlarni tanlashingiz mumkin",
  cancel: "Bekor qilish",
  cancelBonus: "Bonusni bekor qilish",
  cancelBonusConfirm: "Bonusni bekor qilmoqchimisiz? Bonus bekor qilinganda, barcha bonus mablag'lari yo'qotiladi",
  cantEnterTheCode: "Kodni kiritish mumkin emasmi?",
  carriedOut: "Amalga oshirildi; bajarildi",
  cashBackSum: "Tezkor Cashback miqdoriri",
  cashBoxApproveCode: "Tasdiqlash kodi",
  cashBoxApproveCodeHint: "Chiqishni tasdiqlash uchun kassirga kerak bo'ladi",
  cashBoxDeliveryText: "Sizga qulay bo'lishi uchun miqdori {0} dan mablag'larini to'ldirish/mablag'larni yechib olish vaqtida sizga kuryer kelishi mumkin. Kuryerni chaqirish uchun bizga telegramda yozing, login {1}",
  cashbackTitle: "Keshbek",
  cashboxAddress: "Kassa manzili",
  casino: "Kazino",
  casinoBonus: "Kazino bonusi",
  casinoLogin: "{name}-login",
  categoryFromAtoZ: "Kategoriya A dan Z gacha",
  change: "O'zgartirish",
  changeData: "Ma'lumotlarni o'zgartirish\n",
  changeEmail: "Pochtani o'zgartirish",
  changeMethod: "Usulni o'zgartirish",
  changePassword: "Parolni o'zgartirish",
  changePhone: "Raqamni o'zgartirish",
  changeStatusCode: "Kod statusini o'zgartiring",
  changeTheEmail: "Elektron pochtani o'zgartirish",
  changeWallet: "Hamyonni almashtiring",
  changingEmail: "Elektron pochtangizni o'zgartirish",
  changingPhone: "Raqamni o'zgartirish",
  checkRobotText: "Robot emasligingizni tekshirish uchun, \"Tasdiqlayman\" tugmasini bosing\n",
  checking: "Tekshiruvda",
  chooseComfortableAddress: "Tashrif uchun qulay manzilni tanlang",
  chooseDepositViaCryptocurrencyMethod: "“Kriptovalyuta orqali depozit qo‘yish” usulini tanlang",
  chooseVariantOrContinueEnter: "Variantni tanlang yoki kiritishni davom eting",
  chooseVerificationMethod: "Kod yordamida yechib olishni tasdiqlashni o'chirish uchun usulni tanlang",
  clear: "Tozalash",
  clearFavorites: "Tanlanganlarni tozalash",
  clickCheckoutInHeaderOfSite: "Sayt sarlavhasida \"Kassir\" tugmasini bosing",
  clickHome: "\"Bosh ekranga o'tish\" tugmasini bosing",
  clickOnTheOddsYouLike: "O'zingizga yoqqan koeffitsientlarni bosish orqali, shunchaki qalqib chiquvchi oynada tez tikish o'rnating:",
  clickSelectFrontCoin: "Tanga yonidagi “Tanlash” tugmasini bosing, masalan “Tether TRC20”",
  clickShare: "Ulashish-ni bosing",
  clickToAttache: "Fayl biriktirish uchun bosing",
  clickTopMenuToBuyCrypto: "Yuqori menyuda  \"Kripto sotib olish\" tugmasini bosing va \"Bank kartasi\" to'lov usulini tanlang. Min. miqdori - 10.40 USD",
  close: "yoping",
  code: "Kod\n",
  codeAlreadySendFillIt: "Biz tasdiqlash kodini yubordik, uni kiritish maydoniga kiriting\n",
  codeIsWrong: "Kod to'g'ri emas",
  codeSend: "SMS-kod nomerga yuborildi",
  codeSendToEmail: "Kod pochtaga yuborildi",
  codeSendToPhone: "Kod nomerga yuborildi",
  codeSendToTelegram: "Kod Telegram bot orqali yuborildi",
  codeVerificationDisabled: "Kodni tasdiqlash o'chirilgan",
  codeVerificationEnabled: "Kodni tasdiqlash yoqilgan",
  coinSelection: "Tanga tanlash",
  comboBoostBonus: {
    button: "O'ynash",
    content_title: "Kombobustdan qanday foydalanish kerak:",
    good_luck: "Olymp.casino Sizga katta yutuqlar tilaydi!",
    range_left_title: "Voqealar soni",
    range_right_title: "Koeffitsient",
    step_one: "Qadam 1:",
    step_one_description: "Hozirdan yutuqli ekspressingizni yig’ib boshlang va ko’paytirilgan koeffitsientni qanday olish mumkinligiga e’tibor bering.",
    step_three: "Qadam 3:",
    step_three_description: "Siz tanlovingizni qilgandan so'ng, pul tiking! Bonus sizning yakuniy koeffitsientingizni avtomatik ravishda oshiradi. Siz garovlaringizni 'Mening tikishlarim' bo'limida tekshirishingiz mumkin. U COMBOBOOST belgisi bilan belgilanadi.",
    step_two: "Qadam 2:",
    step_two_description: "Ekspress yig’ishda davom eting va bonus ko’payishini kuzating.",
    welcoming_range_title: "Koeffitsientingizni bilib oling.",
    welcoming_text: "Olymp.casino barcha yangi foydalanuvchilar uchun ajoyib yangiliklarga ega! Bustning ishlayotganiga ishonch hosil qilish uchun ushbu xususiyatni o'zingiz sinab ko'ring! Bonusimiz bilan yakuniy koeffitsientingizni oshirish uchun 1,5 yoki undan yuqori koeffitsientda 2 yoki undan ortiq voqeaga ekspress-garov tiking. Shuni yodda tutingki, ekspressda qancha ko'p voqealar bo'lsa, bonusingiz shunchalik ko'p bo'ladi.",
    welcoming_title: "Qo'shimcha tadbirlar Express ko'proq bonuslar!"
  },
  commission: "Komissiya:",
  competitionAction: "Belgilangan o'yinlardan birini o'ynab, turnirda ishtirok eting",
  competitionMembers: "turnir ishtirokchilari",
  competitionParticipants: "Bu yerda ishtirokchilar ro'yxati ko'rsatiladi\n",
  competitionWinners: "Bu yerda g'oliblar ro'yxati ko'rsatiladi\n",
  competitions: "Barcha turnirlar",
  competitionsGames: "Turnirli",
  competitors: "{count} ta turnir ishtirokchisi",
  completeRegistration: "To‘liq ro‘yxatdan o‘tish",
  completeSecuritySettings: "Shaxsiy ma'lumotlaringiz va mablag'laringiz uchun xavfsizlik sozlamalarini to'ldiring",
  completeSignIn: "Avtorizatsiyani yakunlash",
  completed: "Turnir yakunlandi",
  conductError: "Xatolik",
  confirm: "Tasdiqlash",
  confirmData: "Ma'lumotlarni tasdiqlang\n",
  confirmInformation: "Ma'lumotlarni tasdiqlash",
  confirmPersonalData: "Men shaxsiy maʼlumotlarning toʻgʻriligini tasdiqlayman va bu maʼlumotlarni oʻzgartirish mumkin emasligini tushunaman",
  confirmPhoneNumber: "Telefon raqamini tasdiqlang",
  confirmPhoneThroughTelegram: "Telegram ilovasiga kiring va pulni xavfsiz yechib olish uchun telefon raqamingizni tasdiqlang",
  confirmationCode: "Tasdiqlash kodi",
  confirmationEmail: "Email-ni tasdiqlash",
  confirmationPhone: "Telefonni tasdiqlash",
  confirmed: "Tasdiqlangan",
  congratulationsTrustWalletCreated: "Tabriklaymiz! Trust Wallet yaratildi!",
  contact: "murojaat qiling\n",
  continueSecuritySetup: "Xavfsizlik sozlamalariga qaytish",
  converting: "avtomatik ravishda  {0} ga aylantiriladi",
  copeAddressMemo: "Memo muvaffaqiyatli nusxalandi",
  copeAddressWallet: "Hamyon manzili, muvaffaqiyatli nusxalandi",
  copeAddressWalletNew: "Hamyoningiz manzili muvaffaqiyatli ko'chirildi",
  copeCode: "Kod muvaffaqiyatli nusxalandi",
  copeSumText: "Miqdor muvaffaqiyatli nusxalandi\n",
  copy: "Nusxalash\n",
  copyAddress: "Manzilni nusxalash",
  copyCode: "Kodni nusxalash",
  copyTheAddress: "Manzildan nusxa oling",
  countries: {
    bangladesh: "Bangladesh",
    kazakhstan: "Qozog'iston",
    kyrgyzstan: "Qirg'iziston",
    russia: "Rossiya",
    uzbekistan: "O'zbekiston"
  },
  country: "Mamlakat tanlash",
  countryNotFound: "Mamlakat topilmadi, imloni tekshiring",
  countrySelect: "Mamlakat tanlash",
  coupon: "Kupon",
  couponContainsDependentOutcomes: "Kuponda bog'liq natijalar",
  createWalletInTrustWallet: "Trust Wallet-da hamyon yarating",
  cryptoMemo: "Memo",
  cryptoTournament: "Kripto-turnir",
  cryptoWallerSuccessChanged: "Hamyon manzili muvaffaqiyatli o‘zgartirildi",
  cryptoWallet: "Kriptohamyon",
  cryptocurrency: "Kriptovalyuta",
  currency: "Valyuta",
  current: "Joriy",
  currentBalanceIsLessThanTheWithdrawalAmount: "Barcha to'lov usullari mavjud emas, joriy balans tranzaksiya uchun minimal miqdordan kamroq",
  currentRates: "Joriy tariflar",
  customerSupport: "qo'llab-quvvatlash xizmati\n\n",
  customizeDisplayedCoins: "Ko'rsatilgan tangalarni sozlash uchun yuqori o'ng burchakdagi slayderlarni bosing, tokenlarni qo'shish sahifasida qidiruv satriga Doge-ni kiriting",
  cyrillicInPasswordNotAvailable: "Parolda kirill yozuviga ruxsat berilmagan\n",
  data: "Data",
  dataNotSpecified: "Ma'lumotlar ko'rsatilmagan",
  date: "Sana",
  dateFrom: "Kundan boshlab\n",
  dateOfTransaction: "Tranzaksiya sanasi",
  dateTo: "Kungacha",
  deadline: "Oxirigacha qoldi",
  december: "dekabr",
  decline: "Rad etilgan",
  demo: "Demo",
  deposit: "Depozit",
  depositAccount: "Hisobni to'ldirish",
  depositBK: "BK-dan to'ldirish",
  depositBonus: "{bonus} to'ldirishda bonus",
  depositForBonus: "Bonus olish uchun {sum} dan, ortiq depozit qo'ying\n",
  depositNoun: "To'ldirish",
  depositRequired: "Depozitni amalga oshirish kerak <span class='bonus-item__sum'>{sum}</span>",
  description: "Tavsif",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "Onlayn slotlar ➔ pul uchun ✓o'ynang, bepul va ✓ro'yxatsiz. {company} casino taqdim etadi ✓ bepul✓ mashhur✓ zamonaviy o'yin mashinalari, ✓rasmiy ishlab chiqaruvchilardan, ✓saxiy bonuslar ✓ va turli mavzularda.\n\n"
    }
  },
  details: "Batafsil",
  docsWasApproved: "Hujjatlar muvaffaqiyatli tekshirildi",
  docsWasDeclined: "Hujjatlar tekshiruvdan o'tmadi",
  documentAttacheMessage: "Biz ularni 24 soat ichida tekshiramiz. Shundan so'ng, barcha to'lov usullari siz uchun mavjud bo'ladi.",
  documentAttacheSuccess: "Hujjatlaringiz muvaffaqiyatli yuborildi.",
  documentDeleteSuccess: "Hujjatlar muvaffaqiyatli o'chirildi",
  documentNumber: "Hujjat raqami\n",
  documentUpload: "Hujjatlar yuklanmoqda\n\n",
  done: "Tayyor!",
  doneThresholdConditions: "Depozitni qaytarib o'ynash shartlari bajarildi\n",
  download: "Yuklab olish",
  downloadApp: "Ilovani yuklab oling",
  downloadOlimpApp: "Olymp ilovasini yuklab oling",
  download_app: "Olymp ilovasini yuklab oling",
  dropswins: {
    eight: "Tasodifiy vaqtda 9000€ miqdorida pul sovrinlari o'ynatiladi. Q'alaba qozonish uchun o'ynang!",
    eighteen: "Qoidalar va shartlar",
    eleven: "Haftalik turnir sovrinlari jadvali (odattagi haftalar)",
    fifteen: "Kundalik sovrinlar jadvali",
    five: "O'YNANG",
    four: "HAR KUNI",
    fourteen: "Haftalik turnir sovrinlari jadvali (odattagi haftalar)",
    nine: "4 x 62 000€ haftalik turnir",
    nineteen: " 1. Bu Pragmatic Play TM tarmoq kampaniyasi. Ushbu kampaniya 11.02.2021 dan 17.11.2021 mobaynida o'tadi CET (01:01 11.02.2021 dan 00:59 18.11.2021 EET) <br> 2. Kampaniya 10 bosqichda o'tkaziladi, har bir bosqich 4 hafta davom etadi.<br> 3. Barcha aksiyalarning umumiy sovrin jamg'armasi 4 000 000 € bo'lib, u 40 x 62 000 € haftalik musobaqalar va 40 x 63 000 € haftalik sovrinlar o'yinlaridan iborat.<br> 4. Quyida ushbu aksiyaning 7-bosqichining shartlari keltirilgan. Turnirning mexanikasi bosqichga qarab o'zgarib turishiga etibor bering.<br> 5. Tarmoq kompaniyasining har qanday turnirida ishtirok etish yoki sovrinlarni qo'lga kiritish uchun o'yinchilar har qanday ishtirok etuvchi o'yinni ochishlari / shartlarga rozi bo'lishlari kerak.<br> 6. To'rt (4) haftalik turnir va sovrinlar o'ynalishi quyidagi tarzda o'tkaziladi:<br> 27-hafta: 11.08.2021 в 20:01 - 18.08.2021 в 19:59 EET<br> 28-hafta: 18.08.2021 в 20:01 - 25.08.2021 в 19:59 EET<br> 7. Kvalifikatsiyalik o'yinlar:<br> Wolf Gold™, Mustang Gold™, Sweet Bonanza™, John Hunter and the Tomb of the Scarab Queen™, Great Rhino Megaways™, John Hunter and the Book of Tut™, The Dog House™, The Dog House Megaways™, Chilli Heat™, Fruit Party™, Big Bass Bonanza™, Madame Destiny Megaways™, Gems Bonanza™, Wild Wild Riches™, Wild West Gold™, Gates of Olympus™, Power of Thor Megaways™, Buffalo King Megaways™, The Hand of Midas™, Floating Dragon Hold & Spin™, The Magic Cauldron – Enchanted Brew™, Heart of Rio™, Dragon Hot Hold and Spin™, Lucky Lightning™, 5 Lions Megaways™ ",
    one: "Pragmatic Play-dan Drops & Wins tarmoq turniriga qo'shiling, bu erda har bir kishi g'olib bo'lishi mumkin!",
    seven: "Peshqadamlar jadvalning yuqori qismiga chiqing va bitta aylantirishda en yuqori bo'lgan yutuqni qo'lga kiriting.",
    seventeen: "Ushbu turnirda ishtirok etish adolatli bo'lishi uchun barcha o'yinchilar uchun garov hajmi qanday bo'lishidan qat'iy nazar, g'oliblikni ko'paytiruvchi mexanizmdan foydalaniladi. Misol uchun, agar siz 2€ qo'ygan bo'lsangiz va 10€ yutgan bo'lsangiz, unda sizning g'alaba multiplikatoringiz beshga teng. Bunday holda siz besh ochko olasiz. Bitta aylantirishda en yuqori g'alaba bilan Top-1200 peshqadamlar qatoriga chiqing.",
    six: "Taklif qilingan o'yinlarni oching, turnirga qo'shiling va o'ynashni boshlang (minimal garov 0.50 evro).",
    sixteen: "Turnirda avtomatik ravishda ishtirok etish va sovrinlarni qo'lga kiritish uchun kampaniyaga faqat bir marta qo'shilishingiz kerak.",
    ten: "4 x 63 000€ haftalik sovrinlar o'yini",
    thirteen: "Mukofot",
    three: "TURNIRNI",
    twelve: "O'rin",
    twenty: "Haftalik turnirlar",
    twentyfour: "Tezkor Cashback",
    twentyone: " 1. Peshqadamlar jadvali ballar bo'yicha shakllantiriladi va ballar garov miqdorini hisobga olgan holda turnirda ishtirok etadigan har qanday o'yinda olingan bitta spin uchun eng katta yutuq asosida hisoblanadi.<br> 2. Peshqadamlar jadvali real vaqtda yangilanadi va o'yinchilar turnirning ishtirok etadigan o'yinlaridan birini o'ynashda istalgan vaqtda etakchilik jadvalini ko'rishlari mumkin.<br> 3. Agar ikkita (2) yoki undan ortiq o'yinchi etakchilar jadvalidagi bir xil pozitsiyada turnirni tugatgan bo'lsa, unda birinchi o'rinni ko'rsatilgan ballarni birinchi bo'lib qo'lga kiritgan o'yinchiga beriladi.<br> 4. Sovrinlar belgilangan miqdorda o'yinchilarga to'lanadi.<br> 6. Haftalik sovrin jamg'armasi 62 000 € miqdorida jami 1200 pul sovrinini o'z ichiga oladi.<br> 7. O'rin- haftalik sovrinlar < br> 1. €10,000<br> 2. €5,000<br> 3. €2,000<br> 4-10. €1,000<br> 11-20. €500<br> 21-50. €200<br> 51-100. €100<br> 101-300. €50<br> 301-600. €20<br> 601-1200. €10 ",
    twentythree: " 1. Aksiyaning har bir haftasi davomida 7 (7) kunlik sovrinlar o'ynalishi o'tkaziladi.<br> 2. Har bir aksiya davomida shartlarga mos keladigan bitta (1) spin sovrin jamg'armasidan bitta (1) sovrinni olib kelishi mumkin.<br> 3. Sovrinlar tasodifiy asosda o'ynaladi. Qoidalar va sovrinlar jadvallari turnirda ishtirok etayotgan o'yinlarda mavjud. Sovrinlar jadvali real vaqt rejimida yangilanadi, joriy holatni, shuningdek qolgan sovrinlar sonini ko'rsatadi.<br> 4. Turnirda ishtirok etayotgan har bir o'yinda \"\"\"\"Sovrinlar\"\"\"\" ilovasida ko'rsatilgan sovrinlar to'lanadi.<br> 5. Sovrinlar belgilangan miqdorda o'yinchilarga to'lanadi.<br> 6. Sovrinlar o'ynalishida ishtirok etish uchun turnirda ishtirok etayotgan o'yinda(-larda) haqiqiy pulga eng kam deganda 0,50€ miqdorida garov tikishingiz kerak. Bir o'yinchi har kuni bir nechta sovrinlarni qo'lga kiritishi mumkin.<br> 7. Sovrinlar o'ynalishi har kuni (i) 00:59 EEST/EET yoki (ii) barcha sovrinlar berilgandan so'ng (avval nima sodir bo'lishiga qarab) to'xtatiladi.<br> 8. Agar ma'lum bir kundalik o'yinining sovrin jamg'armasi to'liq taqsimlanmasa, unda ortiqcha mablag' PragmaticPlay ™ ning xohishiga ko'ra keyingi bosqichdagi sovrin jamg'armasiga o'tkaziladi.<br> 9. Haftalik sovrin jamg'armasi jami 63,000 € ni tashkil etadi, kunlik sovrin jamg'armasi esa 500 pul mukofotlari va 9,000 € miqdorida bepul raundlarni o'z ichiga oladi.<br> 10. Miqdori - kundalik sovrinlar < br> 1 X €1,000<br> 2 X €500<br> 5 X €100<br> 12 X €50<br> 110 X €20<br> 370 X €10<br> 11. G'oliblar o'z sovrinlarini pul shaklida oladi. Pul mukofotlari avtomatik ravishda turnir tugaganidan keyin {baseLink} kazinosidagi hisobiga kiritiladi.<br> 12. {baseLink} istalgan vaqtda aksiya shartlarini o'zgartirish yoki bekor qilish huquqini o'zida saqlab qoladi.<br> 13. {baseLink} umumiy qoidalari va shartlari amal qiladi. ",
    twentytwo: "Haftalik sovrinlar o'yini",
    two: "500 000€ miqdorida sovrin jamg'armasi haftasiga 125 000€ -dan bosqichlar o'rtasida taqsimlanadi! Ishtirok etish uchun quyidagi bosqichlarni bajaring!"
  },
  email: "Email",
  emailNeedValid: "Tekshirish kodi pochtangizga keladi",
  emailSuccessfullyApproved: "Elektron pochta muvaffaqiyatli tasdiqlandi",
  emptyGames: "Biz siz uchun bunday o'yinlarni topa olmadik",
  emptyPromoPage: "Joriy aktsiyalari bu erda ko'rsatiladi",
  ended: "Bajarildi",
  engineeringWorks: "5 daqiqadan so'ng saytda texnik ishlar yuritiladi",
  english: "Inglizcha",
  enter: "Aloqa",
  enterCode: "Kodni kiriting",
  enterCodeFromEmail: "Elektron pochtadagi kodni kiriting",
  enterCorrectPhoneNumber: "To'g'ri telefon raqamini kiriting",
  enterCryptoWallet: "Kripto hamyonni kiriting",
  enterCryptoWalletOnProfilePage: "Yutuqlaringizni olish uchun shaxsiy hisobingizga Doge kripto hamyonini kiriting",
  enterGameName: "O’yinning nomini kiriting",
  enterGameNameOrProvider: "O'yin yoki provayder nomini kiriting",
  enterMoreCharacters: "Ko'proq belgilarni kiriting!",
  enterPromoCode: "Promo-kodni kiriting",
  enterSMS: "SMS-dagi kodni kiriting",
  enterSixDigitCode: "Ilovadan 6-talik kodni kiriting",
  enterValidEmail: "To'g'ri elektron pochtangizni kiriting",
  enterWalletAddress: "Turnirdagi yutuqni hisoblash uchun Doge kripto hamyonining manzilini hozir yoki keyinroq ko'rsating.\n",
  enterYourBankCardDetails: "Bank kartangiz ma'lumotlarini kiriting, to'lov tizimining shartlariga rozilik bildiring va \"To'lash\" tugmasini bosing",
  entrance: "Kirish",
  err404subtitle: "Sizni asosiy sahifada kutamiz!",
  err404title: "Afsuski, hech narsa topilmadi… ",
  error: "Xatolik",
  errorPasswordField: "Parolda raqamlar, katta harflar bo'lishi kerak va kichik harflar",
  errorPaymentDataInitialization: "To'lov tizimini initsializatsiya qilishda xatolik",
  errorPaymentUrlInitialization: "To'lovni initsializatsiya qilishda xatolik",
  errorWhileSendingCode: "Kod bilan xabar yuborilmadi, iltimos, qaytadan so‘rashga urunib ko‘ring\n",
  errorsWhileValidate: "Shaklni tasdiqlashda xatolar\n",
  euro_slot: {
    description: "Euro Slots 2024 onlayn faqat {platform} o'ynash - eng yaxshi rasmiy o'yin slotlari. Onlayn kazinoda bepul va pul bilan o'ynang.",
    end: "Turnir yakunlandi",
    "final": "Finalga chiqing",
    inProgress: "Match davom etmoqda",
    mathPrize: "Matchning mukofot jamg'armasi",
    onWallet: "hisobga",
    prize: "Umumiy mukofat jamg'armasi",
    "prize-short": "MUKOFOT",
    prizeFond: {
      "1\/2": "Mukofot jamg'armasi <p>1/2 final:</p>",
      "1\/4": "Mukofot jamg'armasi <p>1/4 final:</p>",
      "1\/8": "Mukofot jamg'armasi <p>1/8 final:</p>",
      "final": "Finalning <p>mukofot jamg'armasi:</p>"
    },
    rules: {
      "1": "Aksiya 13.06.2024 00-00 GMT +5 dan 14.07.2024 00-00 GMT + 5 gacha o'tkaziladi",
      "2": "Turnirning umumiy sovrin jamg'armasi: {sum}",
      "3": "Jadval bo'yicha turnir tarmog'ida harakatlanadigan slotlar o'rtasida jang bo'lib o'tadi",
      "4": "Muayyan aksiya o'yinining g'alabasiga eng katta hissa qo'shgan foydalanuvchilar mukofot jamg'armasini o'zaro taqsimlaydilar",
      "5": "1/8 bosqich juftliklari uchun sanalar ({sum}):",
      "6": "1/4 bosqich juftliklari uchun sanalar ({sum}):",
      "7": "1/2 bosqich juftliklari uchun sanalar ({sum}):",
      "8": "Final sanalari ({sum}):",
      "9": "Sovrinlarni hisoblash avtomatik ravishda 24 soat ichida o'yin hisobiga amalga oshiriladi"
    },
    stage1: "<span>Ro'yhatdan o'tish</span> va “ISHTIROK ETISH” tugmani bosing.",
    stage2: "Ishtirokchi o'yinlarning <span>istalganiga</span> ga tikish va ball to'plash.",
    stage3: "<span>Eng yaxshi nafar o'yinchi</span> umumiy mukofot jamg'armasini bo'lishadilar",
    stages: {
      "1\/2": "1/2 final",
      "1\/4": "1/4 final",
      "1\/8": "1/8 final",
      "final": "final"
    },
    stagesAtStart: {
      "1\/2": "Final boshlanishidan oldin:",
      "1\/4": "1/2 final boshlanishidan oldin:",
      "1\/8": "1/4 final boshlanishidan oldin:",
      "final": "Final",
      pre: "1/8 final boshlanishidan oldin:"
    },
    start: "Qanday ishtirok etsa bo'ladi",
    table: "Turnir jadvali",
    title: "Euro Slots 2024 turniri - {platformSite} onlayn kazino slotlarini o'ynash",
    winners: "Turnir g'oliblari"
  },
  events: "Voqealar",
  exchangeRateInTenge: "Tengedagi valyuta kursi",
  exit: "Chiqish",
  express: "Ekspress",
  expressCoef: "Ekspress koeffitsienti",
  expressSystem: "Ekspress sistema",
  failed: "Xarakat amalga oshmadihmadi",
  fastBet: "Tezkor tikish\n",
  fastbetDetailedDescription: "Tezkor tikish sizga ikki marta bosish orqali bitta pul tikish imkonini beradi. Oxirgi tikilgan garov miqdorini eslab qolish tikish jarayonini yanada tezlashtiradi.",
  fastbetSetting: "Tez tikish sozlamalari",
  fastbetSum: "Tez tikish miqdori",
  favorite: {
    added: "O'yin sevimlilarga qo'shiladi",
    removed: "O'yin sevimlilardan olib tashlandi"
  },
  favorites: "Sevimlilar",
  february: "fevral",
  fieldRequire: "To'ltirish uchun majburiy maydon",
  fileAttached: "Fayl biriktirilgan",
  fileNotAttached: "Fayl biriktirilmagan",
  fillInformation: "Ma'lumotni to'ldiring",
  fillProfileInfoForWithdraw: "Iltimos, pulni yechib olish uchun shaxsiy maʼlumotlaringizni toʻldiring.",
  fillRequiredInfoBelow: "Iltimos, quyidagi kerakli ma'lumotlarni to'ldiring",
  filter: "Filtr",
  filterByDate: "Sana bo'yicha filtr",
  filtersText: {
    inTheNextSixHours: "keyingi 6 soat ichida",
    inTheNextTwentyFourHours: "keyingi kun ichida",
    inTheNextTwoHours: "keyingi 2 soat ichida",
    nextThreeDays: "keyingi 3 kun ichida",
    nextTwelveHours: "keyingi 12 soat ichida",
    nextWeek: "keyingi haftada",
    today: "Bugun",
    tomorrow: "Ertaga",
    whenever: "istalgan vaqtda"
  },
  findOutAddressOfDogeWallet: "Doge hamyon manzilini bilib oling",
  fine: "Yaxshi",
  firstAuthMessage: "Telefon raqamiga foydalanuvchi nomi va parol bilan SMS yuborildi. Hisobingizni to'ldiring va birinchi yutuqqa o'ting",
  firstDeposit: "Birinchi depozitingizga!\n",
  forCorrectGamePushRefresh: "O'yin to'g'ri ko'rsatilishi uchun yangilash tugmasini bosing",
  forEndCompetition: "Turnir oxirigacha",
  forMoreInformation: "Qo'shimcha ma'lumot uchun\n",
  forStartCompetition: "Turnir boshlanishidan oldin",
  forgotPassword: "Parolni unutdingizmi?",
  fraud: "AML siyosati",
  freeBetsButton: "Tanishish",
  freeBetsCount: "Fribetlar mavjud:",
  freeBetsStepFour: "Garov qiling",
  freeBetsStepOne: "\"Sport\" bo'limini oching",
  freeBetsStepThree: "Hodisani tanlang",
  freeBetsStepTwo: "\"Fribet\" kuponini faollashtiring",
  freeBetsTitle: "Sport uchun «Fribet»",
  freeSpinsInGame: "O'yinda Free Spins",
  freespin: "Frispin",
  freespinsAvailable: "Freprislinlar mavjud",
  from: "{date}-dan boshlab",
  fromAnySum: "Har qanday miqdordan\n",
  fromNumber: "dan",
  fromSmth: "{value} dan\n",
  fulfillConditionsForWithdrawal: "Pul mablag'larini yechish uchun barcha shartlarni bajaring.\n",
  fund: "Mukofot fondi",
  future: "Kelajak",
  game: "O'yin",
  gameDescTemplate: "{gameName} oʻyin mashinasi taniqli {providerName} ishlab chiqaruvchisining onlayn slotidir. Bepul o'yin mashinasini o'ynang {gameName} yoki haqiqiy pul uchun o'ynash uchun ro'yxatdan o'ting",
  gameForMoneyOnlyForAuthUser: "Pul uchun o'yin faqat avtorizatsiyadan o'tgan foydalanuvchilar uchun mavjud",
  gameInOtherTab: "O'yin boshqa ilovada ochiq",
  gameNotAvailableBonus: "Bonus shartlari tufayli o'yin mavjud emas\n",
  gameNotAvailableGeoRestriction: "Oʻyin sizning hududda mavjud emas",
  gameNotFound: "Oʻyin topilmadi",
  gameTitleTemplate: "O'yin mashinasi {gameName}. {company} onlayn Casinosida bepul o'ynang",
  gameUnavailable: "O'yin vaqtincha mavjud emas",
  game_categories: "O'yinlar toifalari",
  games: {
    tryOther: "Boshqa o'yinlarni o'ynab ko'ring"
  },
  gamesNotFound: "O'yinlar topilmadi",
  geoRestrictionDesc: "Afsuski, bu oʻyin sizning hududda mavjud emas.",
  geoRestrictionDescLine2: "Katalogdan boshqa o'yinni tanlashingizni tavsiya qilamiz",
  get: "Oling",
  getBonus: "Bonus olish",
  getBonusByPromoCode: "Promo-kod bo'yicha bonus olish",
  getGainFromFreeSpins: "Frispins bilan g'alaba qozonish",
  getNewCode: "Yangi kodni olish",
  getSMS: "SMS kodini oling",
  go: "O'tish",
  goBack: "Ortga qaytish",
  goToGame: "O'yinga o'ting",
  goToGames: "Ойындарға өту",
  goToHome: "Asosiy sahifaga qaytiыр",
  goToOlimpCasinoAndPlayFavoriteGames: "Olimp Casino-ga o'ting va sevimli o'yinlaringizni o'ynang :)",
  goToVolet: "Saytiga o'ting volet.com (advcash)",
  goToWallet: "Hamyonga o'ting",
  goesNow: "Hozir bo'layotgan",
  gold: "Oltin",
  guarantee: {
    five: "O'yinni mustaqil ravishda rad etish. Agar o'ynash istagini kamaytirish uchun siz bizning kazinoimizning qo'llab-quvvatlash jamoasiga hisobni blokirovka qilishni so'rab murojaat qilsangiz, sizning so'rovingiz amalga oshiriladi. Pleer profilini qaytarib olishni bekor qilish mumkin. Boshqa holatda, o'yinchi xohishiga ko'ra, u muddati tugagandan so'ng tiklanishi mumkin.",
    four: "O'yinga shaxsiy kirishni cheklashni istagan o'yinchilar uchun quyidagi variantlar ishlab chiqilgan:",
    one: "Mas'uliyatli o'yin",
    seven: "Kirishni cheklash. Agar siz o'zingizni qimor o'yinlarini ta'minlaydigan yoki reklama qiladigan turli saytlardan himoya qilmoqchi bo'lsangiz, maxsus dasturlardan foydalanishingiz kerak. Bu filtrlash tizimlarini yaratadi va qimorga qaramlikka moyil bo'lgan foydalanuvchilar uchun xavfsiz onlayn tajribani ta'minlaydi. Bundan tashqari, bu dastur bolalarning kiruvchi manbalarga kirishini oldini olish uchun ishlatilishi mumkin. Bunday dasturlarga misollar: Net enaga (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).",
    six: "Maxsus yordam. Agar qimorga qaramlik rivojlansa, o'yinchilar malakali mutaxassislardan yordam so'rashlari mumkin. Sizga yordam berishi mumkin: Gamblers Anonim (www.gamblersanonymous.org.uk) - qaram o'yinchilarga yordam beradigan anonim o'yinchilar xalqaro jamiyati; GamCare (www.gamcare.org.uk) - ingliz tilida so'zlashadigan tashkilot, o'yinchilarga qaramlikdan xalos bo'lishga yordam beradi; Gambling Therapy (www.gamblingtherapy.org) - Buyuk Britaniyada umumiy kasallikka qarshi kurashda malakali yordam ko'rsatadigan tashkilot.",
    three: "Agar siz qimorga ozgina qaram bo'lib qolsangiz, birinchi navbatda qimor o'yinlari siz uchun nima ekanligini bilib oling. Agar o'yin hayot qiyinchiliklaridan qochishga urinish bo'lsa, bo'sh vaqtingizning deyarli hammasini olasa va ishingizga xalaqit bersa, bu birinchi qo'ng'iroq. Agar siz o'ynash uchun pul qarz olsangiz va kuningizni usiz tasavvur qila olmasangiz, bu sizga keskin o'zgarish kerakligini ko'rsatadigan aniq ko'rsatkichdir.",
    two: "{titlePure} saytda o'ynaydigan foydalanuvchilar oldida muayyan majburiyatlarga ega. Casino ma'muriyati o'yinchilarga mumkin bo'lgan qimorga qaramlikni engishga yordam berishga tayyor. O'yinning mohiyati - ijobiy his -tuyg'ularni etkazish va yengillik berish.Albatta, muvaffaqiyatsizliklar bo'lishi mumkin, lekin hech qanday holatda bu moliyaviy yoki ijtimoiy qiyinchiliklarga olib kelmasligi kerak."
  },
  hasMinimalDeposit: "Minimal depozit qo'yildi\n",
  haveActivatedFastbetMode: "Siz tez tikish rejimini faollashtirdingiz. Qoidalarni ko'rish uchun, iltimos, bosing",
  haveNotEmailContactUs: "Agar sizning pochtangizga xat kelmagan bo'lsa, iltimos, \"Spam\" va \"Promoaksiyalar\" papkasini tekshiring yoki  {0} bilan bo'g'laning",
  haveNotPhoneContactUs: "Agar sizgning telefon raqamingizga SMS kelmasa, {0} bilan bog'laning",
  here: "Bu yerga",
  hiddenConditions: "Yashirin shartlar",
  hide: "Yashirish",
  hideBonusCondition: "Bonus shartlarini yashirish\n",
  hideDetails: "Tafsilotlarni yashirish",
  history: "Tarix",
  historyBets: "Garovlar  tarixi",
  historyPayments: "Tranzaksiya tarixi",
  historyTransactions: "Tranzaksiya tarixi",
  hotGame: "Issiq",
  hotGames: "Issiq o'yinlar",
  hotToBuyCryptoCurrency: "Kriptovalyutani qanday sotib olish mumkin?",
  howCanBuyCryptocurrency: "Kripto valyutasini qanday sotib olaman?\n",
  howCreateCryptoWallet: "Kripto hamyonini qanday yaratish mumkin?in?\n",
  howCreateWallet: "Hamyonni qanday ochish kerak?",
  howToCreateCryptoWallet: "Kripto hamyonini qanday yaratish mumkin?",
  howToFindOutWalletNumber: "Hamyon raqamini qanday topish mumkin?",
  howToInstallApp: "Ilovani qanday o'rnatish kerak?",
  howToViewMyCryptoWalletInOlimp: "Olimpda kripto hamyonimni qanday ko'rish mumkin?",
  howTopUp: "Qanday to'ldirish kerak",
  howTransferCrypt: "Kripto valyutani qanday o'tkazish kerak",
  howTransferCryptStep1: "Hamyonga yoki  birjaga kiring",
  howTransferCryptStep2: "Tanlangan tangani toping {currency} ",
  howTransferCryptStep3: "Bizning hamyonimiz manzilini kiriting ",
  howTransferCryptStep4: "Miqdorni ko'rsating va yuboring ",
  iPaid: "Men to'ldirdim\n",
  idWasCopied: "Tranzaksiya id-sini nusxaladingiz",
  inSettings: "sozlamalarda\n",
  information: "Ma `lumot",
  informationConfirmWithdraw: "Xavfsizlik va pul yechib olish uchun barcha ma'lumotlaringizni tasdiqlang.\nElektron pochta manzilingizni yoki telefon raqamingizni o'zgartirish uchun murojaat qiling",
  informationConfirmWithdrawSupport: "qo'llab-quvvatlash xizmati\n\n",
  informationForUpdateProfileData: "Kontakt ma'lumotlarini yangilash uchun qo'llab-quvvatlash xizmatiga murojaat qilishingiz kerak",
  installApp: "Ilovani o'rnatish uchun {0}",
  installTrustWalletApp: "Trust Wallet ilovasini o'rnating",
  instant: "Tez",
  instantCash: "Keshbek",
  instantCashback: "Tez cashback",
  instantWithdrawal: "Tezda chiqarish",
  instantly: "Bir zumda",
  insufficientFundsAvailable: "Mablag' etarli emas. Mavjud:",
  invalidCryptoWallet: "Hamyon manzili noto‘g‘ri",
  invalidDateFormat: "Noto'g'ri sana formati",
  invalidDateInterval: "Tanlangan interval noto‘g‘ri",
  invalidStartDate: "Boshlanish sanasi noto‘g‘ri",
  iosWebAppInstruction: "iOS ko'rsatmalari",
  jackpot: "Jekpot",
  jackpotGame: "Jekpot bilan",
  january: "yanvar",
  july: "iyul",
  june: "iyun",
  kazakh: "Qozoqcha",
  kycPolicy: "KYC siyosati",
  latestGames: "So'nggi o'yinlar",
  leftCount: "Qoldi {count}",
  leftDeposit: "{sum} to'ldirish qoldi",
  licenseCuracao: "Veb-sayt mazmuni Perantia N.V.ga tegishli va boshqariladi. (\n<a href='https://{domain}' target='_blank'>{domain}</a>) litsenziya egasi sifatida (Kyurasao litsenziyasi № 365/JAZ). Barcha huquqlar himoyalangan va qonun bilan himoyalangan.",
  lineOn: "Kelasi o'yin {date}",
  linkIsReady: "Havola tayyor",
  liveCashBackDesc: "{company} eksklyuziv bonusni taklif etadi, bu faqat bizning VIP mijozlarimiz uchun mavjud! “LIVE Casino” toifasidagi oʻyinlarga garov tiking va yoʻqolgan garovlar miqdoriga qarab hisobingizga Cashback oling!",
  liveCashback: "Live cashback",
  liveCashbackHistory: "Live cashback tarixi",
  live_casino: "LIVE Kazino",
  loading: "Yuklanmoqda",
  loadingLanguage: "Til yuklanmoqda",
  lobby: "Asosiy sahifa",
  login: "Kirish",
  loginCopied: "Sizning loginingiz ko'chirib olindi",
  loginErr: "{name} tizimiga kirishda harflar bo'lmasligi kerak!",
  loginTelegram: "Telegram yordami orqali kiring",
  logoutFromSystem: "Tizimdan chiqish",
  lose: "Mag'lubiyat",
  losers: "Yutqazilgan",
  lottery: "Lotereya",
  mainPage: "Bosh sahifa\n",
  makeABet: "Garov tikish",
  makeBet: "Garov tikish",
  makeDeposit: "Depozit kiritish",
  march: "marta",
  matchClosed: "Match yopildi\n",
  matchEnded: "Match tugadi\n",
  matchNotFound: "Match topilmadi",
  matchPlanned: "Rejalashtirilgan match\n",
  matches: "Matchlar",
  maxBet: "Maksimal stavka",
  maxForExpress: "Ekspress uchun maksimal",
  maxLength: "Maksimal maydon uzunligi {length}",
  maxOutput: "Chiqarishning minimal miqdori",
  maxPay: "To'lovning maksimal miqdori",
  maxSum: "Maks. miqdor\n",
  maxValue: "Maksimal qiymat {value}\n",
  maxValueShort: "Maks: {value}",
  maxWithdrawSum: "Chiqarishning Maksimal miqdori",
  maximumPayment: "Maksimal to'lov miqdori:",
  may: "may",
  messageSMS: "SMS-kodni kiriting",
  messages: "Yangi xabarlar",
  middleName: "Otasini ismi",
  minBet: "Minimal stavka",
  minDepositForBonus: "Qadamni yakunlash uchun kamida {sum} miqdorida depozit qo'ying",
  minLength: "Minimalmaydon uzunligi {length} ",
  minLengthPassword: "Minimal parol uzunligi {min} belgi\n",
  minOutput: "Chiqarishning minimal miqdori",
  minPay: "Minimal to'lov miqdori",
  minSum: "Min. miqdori\n",
  minValue: "Minimal qiymat {value}",
  minValueShort: "Min: {value}",
  minimalDeposit: "Minimal depozit",
  minimalLengthOfCode: "Minimal kod uzunligi {num} belgi",
  minimalSum: "Minimal miqdor",
  minimumPayment: "Minimal to'lov miqdori:",
  minimumTransfer: "Hisobga o'tkazilgan minimal miqdori:",
  modal_telegram: "Bizning kanalda siz faol bonuslar, haftalik o'yinlar va boshqa ko'p narsalarni topasiz va bot bilan siz hech qachon saytga kirish huquqini yo'qotmaysiz!\n",
  more: "Ko'proq",
  moveToBonus: "Bonusga o'ting",
  moveToMessages: "Xabarlarga o'ting\n",
  myBalances: "Mening balanslarim",
  myBonuses: "Mening bonuslarim",
  name: "Ism",
  namePerson: "Ism",
  nameTheCheckout: "Kassirga hamyon manzilini nomlang",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "BetGames",
    fantasy: "Fantasy",
    fast: "Tez",
    jetx: "JetX",
    line: "Liniya",
    live: "Live",
    liveGames: "LiveGames37",
    lottery: "Lotereya\n",
    online: "Live Kazino\n",
    slot: "Slotlar",
    sportGames: "Tezkor o'yinlar",
    table: "Stol",
    turboGames: "Turbo games",
    vSport: "V-Sport",
    virtualGames: "Virtual",
    worldcup: "Jahon chempionati-2022"
  },
  navLinks: {
    bonuses: "Bonuslar",
    home: "Asosiy",
    homeCasino: "Kazino",
    posts: "Xabarlar",
    profile: "Profil",
    promo: "Promo",
    sport: "Sport",
    tournament: "Turnirlar"
  },
  needConfirmProfileInformation: "Bonusni faollashtirish uchun profilingizdagi ma'lumotlarni tasdiqlang",
  needDeposit: "Depozit qilinishi kerak\n",
  needSettingsSecurity: "Siz xavfsizlik sozlamalaridan o'tishingiz kerak\n",
  needToExecuteConditions: "Shartlarni bajarish kerak\n",
  never: "Hech qachon",
  "new": "Yangi",
  new2: "Yangi",
  newBonusAvailable: "Siz uchun yangi bonus mavjud",
  newGame: "Yangi",
  newMessage: "Yangi xabar",
  newMessages: "Yangi xabar",
  newOne: "Yangi",
  newVersionReloadPage: "Sayt versiyasi yangilandi, to'g'ri ishlashi uchun sahifani yangilang",
  newYearPromocodes2025: {
    NY25DAY1: "Santa's​ Gift​ ​o'yinida​ 50​ FS",
    NY25DAY10: "Sportga​•​fribet!",
    NY25DAY11: "Santa's​ ​Great​ Gifts​ o'yinida​ ​50​ FS",
    NY25DAY12: "Royal​ Xmass​ 2​ o'yinida​ 75​ FS",
    NY25DAY13: "75%​•​depozitga​•​va​•​75​•​FS​•​sovg'aga!",
    NY25DAY14: "Santa's​ Xmas​ Rush​ o'yinida​ ​100​ ​FS",
    NY25DAY2: "Sportga​•​fribet!",
    NY25DAY3: "50%​•​depozitga​•​va​•​50​•​FS​•​sovg'aga!",
    NY25DAY4: "Buffalo​ ​Power:​ Christmas​ o'yinida​ 75​ FS",
    NY25DAY5: "75%​•​depozitga​•​va​•​75​•​FS​•​sovg'aga!",
    NY25DAY6: "Royal​ Xmass​ ​o'yinida​ 75​ ​FS",
    NY25DAY7: "100%​•​depozitga​•​va​•​100​•​FS​•​sovg'aga!",
    NY25DAY8: "Sugar​ Rush​ Xmas​ ​o'yinida​ ​100​ FS",
    NY25DAY9: "50%​•​depozitga​•​va​•​50​•​FS​•​sovg'aga!"
  },
  next: "Keyin",
  nextGames: "Ko'proq ko'rsatish",
  no: "Yo'q",
  noAccount: "Hisob yo'q",
  noBetsInHistory: "Tarixingizda garovlar yo'q",
  noConnectionTryAlready: "Internetga ulanish yo'q. Internetga ulaning va qaytadan urinib ko'ring.\n",
  noDeposit: "Depozitsiz",
  noFavoritesYet: "Sevimlilarda hali hech narsa yo'q",
  noMatchSelected: "Hech qanday match tanlanmagan yoki liniyada hech qanday voqea yo'q!\n",
  noResults: {
    bets: "Bu erda Sizning bahslaringiz ko'rsatiladi",
    bonuses: "Bu erda mavjud bonuslar ko'rsatiladi",
    competitions: {
      active: "Bu erda faol turnirlar ko'rsatiladi",
      all: "Bu erda faol turnirlar ko'rsatiladi",
      ended: "Bu erda o'tgan turnirlar ko'rsatiladi",
      future: "Bu erda kelajakdagi musobaqalar ko'rsatiladi"
    },
    gamesNotFound: "O'yinlar topilmadi",
    gamesSearch: "Sizning so'rovingiz bo'yicha o'yinlar topilmadi, boshqa so'rovni kiritishga harakat qilib ko'ring",
    messages: "Bu erda Sizning xabarlaringiz ko'rsatiladi",
    payin: "Sizda mavjud to'ldirish usullari yoʻq",
    payout: "Sizda mavjud olish usullari yo'q",
    simple: "Hech qanday natija yo'q",
    transactions: "Bu erda Sizning tranzaksiyalaringiz ko'rsatiladidi",
    withdraw: "Pulni yechib olish boʻyicha soʻrovlaringiz shu yerda koʻrsatiladi"
  },
  noSelectionsForBetting: "Tikish uchun natijalar tanlanmagan",
  nomination: "Turnir nominatsiyasi\n",
  nonBonusGame: "O'yin bonus dasturida ishtirok etmaydi. Hisobingizni asosiysiga o'tkazamiz.",
  nonBonusGameBetsNotCountInVager: "O'yin bonus dasturida ishtirok etmaydi. Tikishlar bonus veydjeri uchun hisobga olinmaydi",
  nonBonusGameWithoutBalance: "O'yin bonus dasturida ishtirok etmaydi. O'ynash uchun asosiy hisobni to'ldiring.",
  notBonuses: "Hozirda bonuslar mavjud emas",
  notCompetition: "Hozirda faol turnirlar yo'q",
  notConfirmed: "Tasdiqlanmagan",
  notDeposit: "To'ldirishlar bo'lmadi",
  notEnoughEventsForExpress: "Ekspress uchun hodisalar etarli emas",
  notEnoughEventsForSystem: "Sistema uchun hodisalar yetarli emas",
  notEnoughMoneyToWithdraw: "Yechib olish uchun pul yetarli emas\n",
  notEnoughVventsForSystem: "Sistema uchun hodisalar yetarli emas",
  notInterested: "Qiziq emas",
  notLogin: "{name} loginini kiriting!",
  notNow: "Hozir emas",
  notPass: "Parolni kiriting!",
  notSufficient: "etarli emas",
  notValidValue: "Noto'g'ri qiymat",
  notification: "Bildirishnoma",
  november: "noyabr",
  nowInLine: "Hozir liniyada\n",
  nowPlayed: "Hozir qaytarib yutib olindi",
  numberErr: "Iltimos, ro'yxatdan o'tish paytida ko'rsatilgan raqamni tekshiring",
  numberOfWallet: "Hamyon raqami",
  october: "oktyabr",
  onAccountBK: "BC hisobida",
  oneClick: "Bir marta bosish bilan bankni ko'paytiring",
  online: "Onlayn",
  onlyForYou: "Faqat siz uchun",
  open: "Ochiq",
  openAppTrustWallet: "Ilovani oching va sizda ikkita funktsiya mavjud bo'ladi - yangi hamyonni ro'yxatdan o'tkazish yoki mavjudini tiklash. \"Yangi hamyon yaratish\" tugmasini bosing",
  openEmail: "Elektron pochta oching",
  openGameNewTab: "O'yinni ochish uchun tugmani bosing",
  openSafari: "Safari-da oching",
  openSafariIfAnotherBrowser: "Agar siz boshqa brauzerda bo'lsangiz, ushbu sahifani Safari brauzerida oching",
  openTelegramBot: "Telegram-botni ochish",
  operations: "Operatsiyalar",
  orders: "Buyruqlar",
  ordinary: "Ordinar",
  ordinarySeries: "Yakka stavkalar seriyasi",
  other: "Boshqalar\n",
  otherSections: "Boshqa bo'limlar",
  ourSocialMedia: "Bizning ijtimoiy tarmoqlarimiz",
  ourSocialMediaShort: "Bizning ijt. tarmoqlar",
  out: "Chiqish",
  output: "Xulosa",
  outputModalTitle: "Yechib olishni tasdiqlash",
  outputSuccess: "Сhiqarish muvaffaqiyatli yakunlandi!",
  overallCoef: "Umumiy koeffitsient",
  page: "Sahifa",
  pageErr: "sahifa topilmadi",
  pageErrDesc: "Sahifa o'chirildi yoki manzil noto'g'ri kiritildi\n",
  pageNotFound: "Sahifa topilmadi!",
  pageNotFoundDesc: "Sahifa o'chirildi yoki manzil noto'g'ri kiritildi\n",
  participant: "Ishtirokchi",
  participate: "Ishtirok etish",
  passErr: "Parolni unutdingizmi?",
  passMessage: "Parol raqamlar, katta va kichik harflardan iborat bo'lishi kerakmi?",
  passportIndex: "Pasport raqami / ID",
  password: "Parol",
  passwordChanged: "Parol o'zgartirildi",
  passwordErr: "Ro'yxatdan o'tish",
  passwordNew: "Yangi parol",
  passwordSuccess: "Parol muvaffaqiyatli tiklandi",
  passwordTheSame: "Parol joriy paroldan farq qilishi kerak",
  past: "O'tmishdagi",
  pay: "To'lov",
  payBonusErr: "Bonusni sotib olish uchun kamida quyidagi miqdorda depozit qo'yish qolgan",
  payMethod: "To'ldirish usuli",
  payMethods: "To'ldirish usullari",
  paymentMethod: "To'lov usuli:",
  paymentSuccess: "Pul o'tkazish muvaffaqiyatli yakunlandi!",
  payoutPayTrxsExistsText: "Pul mablag'larni yechish uchun kamida bitta to'ldirishni amalga oshirish kerak",
  payoutThresholdStatusText: "Pul mablag'larini yechish uchun {count} pul tikishingiz kerak",
  period: "Davr",
  personInformationIsApprove: "Ma'lumotlar qabul qilindi, hisob himoyalangan",
  personalArea: "Shaxsiy kabinet",
  personalData: "Shaxsiy ma'lumotlar",
  personalDataApproved: "Shaxsiy ma'lumotlar tasdiqlangan\n",
  personalDataIsFilled: "Shaxsiy ma'lumotlar to'ldirilgan\n",
  personalDataSuccessfullyEdited: "Shaxsiy ma'lumotlaringiz muvaffaqiyatli o'zgartirildi",
  phone: "Telefon",
  phoneErr: "Telefon raqamida harflar bo'lishi mumkin emas!",
  phoneNum: "Telefon raqami",
  phoneSuccessfullyApproved: "Telefon muvaffaqiyatli tasdiqlandi",
  pickUpBonus: "Bonusni oling",
  place: "O'rin",
  placeAQuickBet: "Tez pul tikish?",
  places: "Mukofot o'rinlar:",
  placesCount: "{count} joy",
  placesPrice: "Sovrinlar",
  play: "O'ynash",
  playAviator: "Aviator o'ynash",
  playBonus: "Tabriklaymiz, siz bonusni yutib oldingiz! Pul mablag'larini balans {count} miqdorida to'ldirilganidan keyin chiqarishga bo'ladi",
  playBonusEnded: "Bonus yakunlandi. O'yinni davom ettirish uchun hisobingizni {count} miqdorida to'ldiring",
  playForMoney: "Pul uchun o'ynash",
  playGamesInCategoryes: "Kategoriyalardan o'yinlarni o'ynang",
  playWithoutBonus: "Bonussiz o'ynash",
  playingInAppMoreConvenient: "Ilovada o'ynash qulayroq\n",
  pleaseConfirmAgreementToTheTerms: "Iltimos, shartlarga roziligingizni tasdiqlang\n",
  pleaseConfirmInformation: "Iltimos, ma'lumotni tasdiqlang",
  pleaseSelectOutcome: "Iltimos, natijani tanlang",
  pleaseUseNumberOfCharacters: "Iltimos, {num} belgilaridan foydalaning",
  point: "Ochkolar",
  points: "ball yo'q | {n} ball| {n} ball | {n} ball",
  postSMS: "SMS kodini yuboring",
  posts: "Xabarlar",
  potentialWin: "Potentsial g'alaba",
  ppenFullBetHistory: "To'liq tikish tarixini ochish",
  preparedForRemoval: "Chiqarishga tayyor (qayta ishlashda)",
  preview: "Qayta ko‘rib chiqish",
  prize: "Mukofot",
  prizes: "G'oliblarning sovg'alar",
  proceed: "Davom ettirish",
  processDeposit: "To'ldirishni qayta ishlash\n",
  processDepositDescription: "Toʻlov yuborildi va toʻlov tizimi tomonidan qayta ishlanmoqda. Mablag'larni o'tkazish muddati bir necha daqiqadan bir necha kungacha bo'lishi mumkin\n",
  processWagerFromBonusBalance: "Bonus balansidan veyjerni bajarish",
  processWagerFromDeposit: "Depozit summasidan veyjerni bajarish",
  processed: "Qayta ishlashda",
  processing: "Qayta ishlashda",
  promo: "Aksiyalar",
  promoCodeActivationSuccess: "Promo-kod muvaffaqiyatli faollashtirildi",
  promoGames: "Bonus o'yinlari",
  promoMaxBetExceeded: "{bet} {currency} tikish uchun ishlatiladigan maksimal tikish miqdori",
  promoNotFound: "Faol aktsiyalari yo'q",
  promocode: {
    activate: "Promokodni faollashtiring",
    placeholder: "Promokod",
    title: "Promokodini faollashtirish"
  },
  promocodes: {
    NY25DAY1: "Santa's Gift o'yinida 50 FS",
    NY25DAY10: "Santa's Great Gifts o'yinida 50 FS",
    NY25DAY11: "Sportga fribet!",
    NY25DAY12: "Royal Xmass 2 o'yinida 75 FS",
    NY25DAY13: "75% depozitga va 75 FS sovg'aga!",
    NY25DAY14: "Santa's Xmas Rush o'yinida 100 FS",
    NY25DAY2: "50% depozitga va 50 FS sovg'aga!",
    NY25DAY3: "Sportga fribet!",
    NY25DAY4: "Buffalo Power: Christmas o'yinida 75 FS",
    NY25DAY5: "75% depozitga va 75 FS sovg'aga!",
    NY25DAY6: "Royal Xmass o'yinida 75 FS",
    NY25DAY7: "100% depozitga va 100 FS sovg'aga!",
    NY25DAY8: "Sugar Rush Xmas o'yinida 100 FS",
    NY25DAY9: "50% depozitga va 50 FS sovg'aga!",
    NYDAY1: "Hell Hot 100 o'yinida 50 FS",
    NYDAY10: "50% depozitga va 50 FS sovg'aga!",
    NYDAY11: "Sportga fribet!",
    NYDAY12: "Aviator-ga fribetlar!",
    NYDAY13: "75% depozitga va 75 FS sovg'aga!",
    NYDAY14: "Sugar Rush Xmas o'yinida 100 FS",
    NYDAY2: "50% depozitga va 50 FS sovg'aga!",
    NYDAY3: "Sportga fribet!",
    NYDAY4: "JetX-ga fribet!",
    NYDAY5: "75% depozitga va 75 FS sovg'aga!",
    NYDAY6: "Twin fruits of Santa o'yinida 75 FS",
    NYDAY7: "100% depozitga va 100 FS sovg'aga!",
    NYDAY8: "Sugar Rush Xmas o'yinida 100 FS",
    NYDAY9: "50% depozitga va 50 FS sovg'aga!"
  },
  promocodes2025: {
    NY25DAY1: "Santa's Gift o'yinida 50 FS",
    NY25DAY10: "Sportga​•​fribet!",
    NY25DAY11: "Santa's​ ​Great​ Gifts​ o'yinida​ ​50​ FS",
    NY25DAY12: "Royal Xmass 2 o'yinida 75 FS",
    NY25DAY13: "75% depozitga va 75 FS sovg'aga!",
    NY25DAY14: "Santa's Xmas Rush o'yinida 100 FS",
    NY25DAY2: "Sportga​•​fribet!",
    NY25DAY3: "50%​•​depozitga​•​va​•​50​•​FS​•​sovg'aga!",
    NY25DAY4: "Buffalo Power: Christmas o'yinida 75 FS",
    NY25DAY5: "75% depozitga va 75 FS sovg'aga!",
    NY25DAY6: "Royal Xmass o'yinida 75 FS",
    NY25DAY7: "100% depozitga va 100 FS sovg'aga!",
    NY25DAY8: "Sugar Rush Xmas o'yinida 100 FS",
    NY25DAY9: "50% depozitga va 50 FS sovg'aga!"
  },
  promotionNotFound: "Bunday aksiya yo'q",
  protectYouData: "Shaxsiy ma'lumotlaringiz va mablag'laringizni himoya qiling",
  protection: "Maxfiylik siyosati",
  protectionSettingsMessage: "Akkaunt xavfsizligini o'rnatish pulingizni yechish va ularni xavfsiz olib qo'yish uchun zarur",
  providers: "Provayderlar",
  purchaseCryptocurrency: "Kriptovalyuta sotib olish",
  putSend: "Kodni olish",
  queue: "Navbatda",
  reSendCode: "Kodni qayta yuborish\n",
  read: "O'qildi",
  readyForWithdrawOnCashier: "Kassada to'lashga tayyor\n",
  receiveWithdrawalConfirmation: "Elektron pochta/Telegram orqali pul o'tkazishni tasdiqlang",
  recomend: "Tavsiya etiladi",
  recovery: "Parolni tiklash",
  recoveryEmailDesc: "Akkauntingizga kirish uchun ro'yxatdan o'tish paytida ko'rsatgan elektron pochta manzilingizni kiriting",
  recoveryPassword: "Parolni tiklash\n\n",
  recoveryPhoneDesc: "Akkauntingizga kirish uchun ro'yxatdan o'tish paytida ko'rsatgan telefon raqamingizni kiriting",
  recoveryWord: "Qayta tiklash",
  refill: "Hisobni to'ldirish",
  refresh: "Yangilamoq",
  refreshPage: "Sahifani yangilang\n",
  refund: "PULNI QAYTARISH",
  refundPolicy: "Qaytarish siyosati",
  refundWithdrawal: "Pul yechib olishni bekor qilish",
  refundWithdrawalModalDesc: "Haqiqatan ham Pul yechib olishni bekor qilmoqchimisiz? Agar bekor qilsangiz, mablag'lar asosiy balansga qaytariladi.",
  refundWithdrawalNoun: "Pul yechib olishni bekor qilish",
  reg: "Ro'yxatdan o'tish",
  register: "Ro'yxatdan o'tish",
  registrationBonus: "Ro'yxatdan o'tish bonusi\n\n",
  rejected: "Rad etilgan",
  remainingPlay: "Qaytarib o'ynash qoldi",
  repeatPassword: "Parolni takrorlang\n",
  repeatTopUpDesc: "Toʻlov amalga oshmadimi? Qayta urinib ko&#39;raylikmi?",
  replenishment: "To'ldirish",
  requirement: "Talab",
  requisiteDesc: "Hisobni to'ldirish uchun {sum} ni hisob raqamiga o'tkazing. Muvaffaqiyatli to'ldirish uchun miqdor ko'rsatilgan miqdorga to'liq mos kelishi kerak.\n",
  resend: "Qayta yuborish",
  resendCodeCanAfter: "Kodni {0} so'ng qayta yuborishingiz mumkin",
  reset: "Qayta tiklash",
  resetFilters: "Filtrni qayta o'rnating",
  resetIt: "qayta tiklang",
  responsibleGame: "Mas'uliyatli o'yin",
  result: "Xulosa",
  results: "Natijalar\n",
  resultsSearch: "Qidiruv natijalari",
  "return": "Qaytarish",
  rollback: "Orqaga qaytish",
  rules: "Qoida va shartlar",
  rulesDescription: "Qoidalar",
  rulesShort: "Qoidalar",
  rulesTournament: "Turnir shartlari va qoidalari",
  russian: "Ruscha",
  sales: "Sotildi ",
  save: "Saqlash",
  schedule: "Jadval\n",
  scores: "Ballar",
  search: "Qidirmoq",
  searchProviders: "Provayder nomi",
  seats: "Joylar ",
  secretAnswer: "Xavfsizlik savoliga javob",
  secretQuestion: "Nazorat savoli",
  security: {
    five: "Agar sizda axborotni himoya qilish haqida savollaringiz bo'lsa, iltimos, onlayn qo'llab-quvvatlash yoki yordamga xat {support}. Biz sizga yordam berishdan xursand bo'lamiz.",
    one: "Jahon standartlari bo'yicha biznesni yuritish masalasida bizning qat'iy pozitsiyamizni ko'rsatish uchun biz ushbu ma'lumotni himoya qilish to'g'risidagi nizomni e'lon qilamiz.",
    seven: "Axborotni himoya qilish",
    six: "EUROMIRBET D.O.O. Evromirbet D.O.O., Podgorika, Cetinicici tomonidan taqdim etilgan xizmatlar va ma'lumotlar BB, REG. Yo'q. 5-0685623 / 1. Xaridorlarning ma'lumotlarini himoya qilish bo'yicha Tasdiqlash bo'yicha tavsiyalarga binoan, xaridor ma'lumotlarini himoya qilish, 1,2 va Amaldagi algoritmda 256 bitli algoritmda qo'llaniladi",
    three: "{titlePure} anti-spam siyosati amal qiladi. Bizning o'yinchilarimizga yuborilgan barcha elektron pochta, ularning o'yin hisob bilan bog'liq, va, shuningdek, kazino va dolzarb promo materiallar, ularning yangi xususiyatlari haqida ma'lumot o'z ichiga olishi mumkin. Reklama mailings chastota farq qilishi va erishish mumkin 3 kuniga harflar. Aktyorlar tarqatishni rad etish huquqini saqlab qoladilar-bu holda siz onlayn qo'llab-quvvatlash xizmatiga murojaat qilishingiz yoki istalgan vaqtda obunani bekor qilishingiz kerak, xatning pastki qismidagi tegishli havolani bosing. Sizning yutuqlaringiz va sizning to'lovlaringiz haqidagi ma'lumotlar ham qat'iy maxfiydir va xavfsiz muhitda saqlanad",
    two: "Biz ishonamizki, yaxshi ish munosabatlar faqat halollik va ishonchga asoslanadi. Shuning uchun sizning ma'lumotlaringizning maxfiyligi biz uchun juda muhimdir. Sizning operatsiyalaringizning xavfsizligini ta'minlash uchun barcha choralarni ko'rayotganimizni bilib, o'yindan bahramand bo'lishingiz mumkin. Sizning ismingiz, pochta manzilingiz, elektron pochta manzili, telefon raqami, tug'ilgan sanasi, jinsi, IP-manzili va boshqa ma'lumotlar xususiy va maxfiydir va uchinchi shaxslarga o'tkazish, sotish va tarqatish mumkin emas."
  },
  securityAnswer: "Yashirin javob",
  securityQuestion: "Yashirin savol",
  securitySetting: "Xavfsizlik sozlamalari",
  selectAll: "Hammasini belgilash\n",
  selectApproveMethod: "Pul o'tkazishni tasdiqlash usulini tanlang\n",
  selectCountryToReceive: "Manzilingiz bo'yicha joriy takliflar va shartlarni olish uchun mamlakatni tanlang",
  selectPaymentCurrencyAndClickTopUpAccount: "To'lov valyutasini tanlang va \"Hisobni to'ldirish\" tugmasini bosing",
  selectProviders: "Tanlangan provayderlar uchun barcha o'yinlar",
  selectQuestion: "Avval savolni tanlang",
  selectVariable: "Tegishli variantni tanlang",
  sellBet: "Garovni sotish\n",
  send: "Yuborish",
  sendCode: "Kodni yuborish",
  sendCodeError: "Kodni kiritish mumkin emas, murojaat qiling\n",
  sendCodeErrorSupport: "qo'llab-quvvatlashga\n",
  sendCodeRepeat: "Kodni yana yuboring\n",
  sendCodeSuccess: "Kod telefonga yuborildi",
  sendCodeSuccessEmail: "Kod elektron pochtangizga yuborildi",
  sendConfirmationEmail: "Biz tasdiqlovchi elektron pochta manziliga yubordik",
  sendConfirmationPhone: "Biz {phone} raqamiga kod bilan SMS yubordik",
  sendDocuments: "Hujjatlarni yuborish",
  sendSMS: "SMS kodini yuboring",
  sendedCodeToEmail: "Kod pochtangizga yuborildi <br> {email}",
  sendedCodeToPhone: "Kod telefoningizga yuborildi <br> {phone}",
  september: "sentyabr",
  serverErrorTryAgain: "Server xatosi, qayta urinib ko'ring",
  serverErrorTryRefresh: "Server xatosi, yangilashga ko'ring",
  settlementCurrency: "Hisoblash valyutasi",
  sgtv_bonus: {
    block_one_li_four: "10 ta fribetni oling.",
    block_one_li_one: "Bonusni olish uchun balansingizda {sum} {currency} dan boshlab mablag‘ bo‘lishi kerak.",
    block_one_li_three: "Lobbi bonusini faollashtiring.",
    block_one_li_two: "Bonusni faollashtirish uchun istalgan SGTV o'yin provayderiga o'ting.",
    block_one_title: "Bonusni qanday olish mumkin:",
    block_two_li_eight: "Bonus х20 veyjeriga tortiladi. Tikish uchun minimal koeffitsient 1.5 ga teng.",
    block_two_li_eleven: "Olymp u yakka tartibda va istalgan vaqtda taklif shartlarini o'zgartirish yoki bekor qilish, shuningdek biron bir o'yinchini tushuntirishsiz rad etish huquqini o'zida saqlab qoladi.",
    block_two_li_five: "Sport Games bo'limiga kirishda yangi o'yinchiga nominal qiymati {sum} {currency} bo'lgan 10 ta fribet beriladi.",
    block_two_li_four: "Bonus darhol qo'shiladi. Agar tanlangan bonus qo'shilmagan bo'lsa, o'yin boshlanishidan oldin qo'llab-quvvatlash xizmatiga murojaat qilishingiz kerak. Agar siz o'yinni bonussiz boshlasangiz, u hisobga olinmaydi.",
    block_two_li_nine: "Depozitsiz atributlar va depozitsiz bonuslardan olinadigan maksimal yutuq miqdori {sum} {currency} tashkil etadi.",
    block_two_li_one: "Foydalanuvchi faqat bitta bonusga ega.",
    block_two_li_seven: "Bonus faollashtirilgan paytdan boshlab 3 kun ichida mavjud.",
    block_two_li_six: "Fribetlarni  «Boks», «Darts», «Bridj», «Bullittlar», «Tavla» o'yinlarida foydalanish mumkin.",
    block_two_li_ten: "Fribetlar 1.3 dan 5 gacha koeffitsientlarga tikish uchun ishlatilishi mumkin.",
    block_two_li_three: "Bonusni olish uchun siz {sum} {currency} miqdorida to'ldirishingiz kerak.",
    block_two_li_two: "Bonuslar (fribetlar) Sport games TV-da hech qachon garov tikmagan o'yinchilarga beriladi.",
    block_two_title: "Foydalanish shartlari:",
    important_text: "Muhim! Agar siz bonusni faollashtirmasdan o'yinni boshlasangiz, keyinchalik fribetlar qo'shilmaydi.",
    title: "SportGamesTV-da yangi o'yinchilar uchun fribetlar! \"Nard\", \"Boks\", \"Dart\", \"Bridj\", \"Bullitlar\" o'yinlariga 10 ta bepul tikish qo'lga kiriting."
  },
  shallWePlay: "O'ynaymizmi?",
  shortDescription: "Qisqa Tasvir",
  show: "Ko'rsatish\n",
  showAll: "Hammasini ko'rsatish",
  showBets: "Garovlarni ko'rsatish",
  showCodeOnlyForOperator: "Tasdiqlash kodini kassirdan boshqa hech kimga aytmang\n",
  showGame: "O'yinni ko'rsatish",
  showGames: "O'yinlarni ko'rsatish",
  showMatchesStarting: "Boshlanadigan o'yinlarni ko'rsatish:",
  showMoreGames: "Ko'proq o'yinlarni ko'rsatish\n",
  showTerms: "Shartlarni ko'rsating",
  showTransactions: "Tranzaktsiyalarni ko'rsatish",
  signUp: "Roʻyxatdan oʻtish",
  signUpAndVerifyVolet: "Ro'yxatdan o'ting va tekshiruvdan o'ting, bu 15 daqiqa davom etadi",
  signin: "Kirish",
  silver: "Kumush",
  slots: "Slotlar",
  smallDescription: "Turnirning qisqacha tavsifi",
  smsCode: "SMS kodini oling",
  smsInfo: "Sizning raqamingizga SMS-kod yuboriladi",
  smsSendingDesc: "Biz telefon raqamingizga yuborgan kodni kiriting",
  smsVer: "SMS orqali to'lovlarni tekshirish",
  smsVerDisabled: "SMS to'lovlarni tekshirish o'chirilgan",
  smsVerEnabled: "SMS to'lovlarni tekshirish qo'shilgan",
  socialAuthError: "Ijtimoiy tarmoq orqali avtorizatsiya xatosi",
  soonStarted: "Tez kunlarda boshlanadi",
  sort: "Saralash",
  spaceNotAvailableForField: "Ushbu maydonda bo'sh joy qoldirishga ruxsat berilmaydi",
  specifyNumberYourPersonalCryptoWallet: "Maydonga veb-saytida shaxsiy kripto-hamyoningiz raqamini kiriting.",
  spinsBeforeCrediting: "O'tkazilishidan oldin spinlar soni:",
  sportErrorText: "Biz hozirda \"Sport\" bo'limini yangilayapmiz, ammo tez orada hammasini tiklaymiz.",
  sports: "Sport",
  stakeHasBeenSuccessfully: "Sizning tikishingiz muvaffaqiyatli qabul qilindi!",
  startSecuritySetup: "Xavfsizlik sozlamalaridan o'tish",
  stateOfAnAccount: "Hisob holati",
  status: "Holat",
  statusAcc: "Akkaunt maqomi:",
  statusOfTransaction: "Tranzaksiya statusi",
  statusSuccess: "Tasdiqlangan",
  statuses: {
    calculationInProgress: "Hisoblash davom etmoqda",
    inProcess: "Jarayonda",
    notPayed: "To'lanmagan",
    payed: "To'langan"
  },
  sub_telegram: "Telegramga obuna bo'ling",
  success: "Xarakat muvaffaqiyatli o'tdi",
  successEnterTournament: "Ajoyib, siz turnirdasiz!",
  successPromoCode: "Promo-kod muvaffaqiyatli faollashtirilgan",
  sufficient: "yetarli",
  sum: "Summa",
  sumBet: "Garov miqdori",
  sumMoreThanBalance: "Miqdor balansdan ko'proq",
  sumWithdraw: "To'lov miqdori",
  support: "Qo'llab-quvvatlash",
  supportContact: "Qo‘llab-quvvatlash xizmatiga murojaat qiling",
  surname: "Familiyasi",
  suspended: "To'xtatildi\n",
  system: "Sistema",
  table: "Stol",
  tapOnHome: "\"Bosh ekranga qo'shish\" tugmasini bosing va \"Bajarildi\" tugmasini bosing",
  tapOnShareIcon: "Ekranning pastki qismidagi menyudagi Ulashish belgisini bosing",
  term: "To'ldirish muddati",
  termEnrollment: "To'ldirish muddati:",
  termFulfillment: "Shartlarni bajarish muddati:",
  termsAndConditions: "Shartlari va qoidalari",
  termsAndConditionsList: "Foydalanish shartlari",
  timeFulfill: "Shartlarni bajarish vaqti:",
  timeRemaining: {
    txt: "Kodni qayta olish uchun {seconds} soniya qoldi",
    txtPay: "Yangi kodni {seconds} ichida olishingiz mumkin"
  },
  timeToActivateBonus: "Bonusni aktivlantirish uchun vaqt",
  timer: {
    oneLetter: {
      day: "d",
      hour: "h",
      minute: "m",
      second: "s"
    },
    "short": {
      day: "Kun.",
      hour: "Soat.",
      minute: "Daq.",
      second: "Sek."
    }
  },
  tip: "Maslahatlar",
  titles: {
    cashback: "Cashback",
    dropsWins: "Tushishlar va g'alabalar",
    err404: "So'ralgan sahifa mavjud emas",
    fraud: "Firibgarlikdan himoya qilish",
    gameGroups: {
      "GamesByGroup\/slot": "Onlayn slotlar - ro'yxatdan o'tmasdan pul uchun o'yin mashinalarida bepul o'ynang\n"
    },
    home: "{titlePure}",
    profile: "Profil",
    protection: "Axborotni himoya qilish",
    responsibleGame: "Mas'uliyatli o'yin",
    rules: "Qoidalar va shartlar",
    tournaments: "Turnirlar",
    work: "Texnik ishlar yuritilmoqda"
  },
  to: "{date} qadar",
  toFindOutWalletAddressOfCoin: "Tanganing hamyon manzilini bilish uchun asosiy ekranda olmoqchi bo‘lgan tanga ustiga bosing, so‘ngra tranzaksiya tarixiga ega tanga sahifasi ko‘rsatiladi",
  toPromoStart: "Aksiya boshlanishidan oldin",
  toSupport: "qo'llab-quvvatlash xizmatiga\n\n",
  topLines: "Liniya Toplari",
  topUp: "to'ldirish",
  topUpWith: "Bilan to'ldirish",
  topupYourBalance: "Pul uchun o'ynashga balansingizni to'ldiring",
  total: "Jami",
  tournament: "Turnir",
  tournamentCryptoReminderText: "Yutuqlaringizni olish uchun shaxsiy hisobingizda Doge kripto hamyonini ko'rsatishni unutmang ",
  tournamentDescription: "Turnir tavsifi",
  tournamentEnded: "Turnir yakunlandi",
  tournamentGame: "O'yin turnirda ishtirok etadi",
  tournamentGames: "Turnir o'yinlari",
  tournamentMounth: {
    "01": "Yanvar",
    "02": "Fevral",
    "03": "Mart",
    "04": "Aprel",
    "05": "May",
    "06": "Iyun",
    "07": "Iyul",
    "08": "Avgust",
    "09": "Sentyabr",
    "10": "Oktyabr",
    "11": "Noyabr",
    "12": "Dekabr"
  },
  tournaments: "Turnirlar",
  transactionCopied: "Tranzaksiya id-sini nusxaladingiz",
  transactionSuccess: "Tranaksiya muvaffaqiyatli yakunlandindi",
  transactionsIsNotExist: "Sizda hali hech qanday tranzaksiya yo'q",
  transactionsNotFound: "Tanlangan filtrlar bo'yicha operatsiyalar topilmadi. Filtr parametrlarini tahrirlashga harakat qiling yoki {0}",
  transfer: "Tarjima qilish",
  transferAccount: "Hisobga o'tkazish",
  transferAmount: "O'tkazma miqdorini yozing",
  transferAmount2: "O'tkazma miqdorini kiriting",
  transferSuccessfully: "Mablag o'tkazish muvaffaqiyatli yakunlandi!",
  transferTheMoneyAndWait: "Kassirga pul o'tkazing va to'ldirishni kuting",
  transitionDate: "Tranzaksiya sanasi",
  transitionStatus: "Tranzaksiya statusi",
  transitionType: "Tranzaksiya turi",
  turnOff: "O'chiring",
  turnOn: "Yoqish",
  turnOnState: "Kiritilgan",
  turnover: "Aylanma",
  twoFactorAuth: "kki faktorli autentifikatsiya",
  typeOfTransaction: "Bitim turi",
  uncalculated: "Hisoblanmagan",
  underCoinBalanceClickGetButton: "Tanga balansi ostida \"Qabul qilish\" tugmasini bosing.  Keyin manzilni tugma yordamida nusxalashingiz yoki skanerlash uchun shtrix-koddan foydalanishingiz kerak",
  unexpectedErrorWriteToSupport: "Kutilmagan xatolik yuz berdi, lekin biz tez orada uni tuzatamiz.\n",
  unexpected_error_try_again: "Kutilmagan xato, yana urinib ko'ring",
  unhandledErrorTryToRefreshPage: "Kutilmagan xatolik, sahifani yangilab ko'ring",
  unselect: "Belgilanganlarni olib tashlash\n",
  untilStartLeft: "Boshlanishgacha",
  update: "Yangilamoq",
  upload: "Yuklab oling",
  uzbek: "O'zbekcha",
  verification: "Tekshiruvdan o'tish",
  verificationDeclined: "Verifikatsiya rad etildi. Iltimos, qo'llab-quvvatlash xizmatiga murojaat qiling.",
  verificationDeclinedInfo: "Hujjatlar tekshiruvdan o'tmadi. Iltimos, hujjatlarni qayta biriktiring yoki qo'llab-quvvatlash xizmatiga murojaat qiling.",
  verificationInProgress: "Verifikatsiya amalga oshirilmoqda. Iltimos, kuting.",
  verificationsSMSDesc: "To'lovlarni verifikatsiya qilish uchun ro'yxatdan o'tishda ko'rsatgan telefon raqamingizni tasdiqlang",
  verifyYourAccount: "Akkauntingizni verifikatsiyalang",
  virtuals: "V-Sport",
  wager: "Stavka tikish",
  wagerGame: {
    accessAfterRolePlay: "O'yin bonus stavka tugagandan so'ng mavjud bo'ladi",
    gamesWagering: "Tikish mumkin bo'lgan o'yinlar",
    nowPlayed: "Hozir qaytarib yutib olindi",
    remainForPlay: "Qaytarib o'ynash qoldi"
  },
  wallet: "Hamyon\n",
  walletCopied: "Hamyon nusxalashdi",
  walletId: "Hamyon manzili",
  walletNotLinked: "Hamyon ulanmagan",
  way: "Chiqarish usuli",
  ways: "Chiqarish usullari",
  wbCashboxActiveText: "Bonus hisobiga depozit uchun 100% olish uchun hisobingizni {minSum} hisobidan toʻldiring. Bonus tikilgandan so'ng asosiy hisob mavjud bo'ladi.",
  wbCashboxNotActiveText: "Bonus hisobiga depozit uchun 100% olish uchun shaxsiy hisobingizda bonusni faollashtiring.",
  wbWaitOnProfile: "Hisobingizdagi \"Bonuslar\" bo'limida sizni xush kelibsiz bonus kutmoqda",
  welcomeBonus: "Welcome bonusingizni",
  welcomeBonusCasino: "Welcome bonusingizni kazino",
  welcomeBonusDescription: "Bir soat ichida toʻlovni amalga oshirishga shoshiling va omonatingiz uchun <span class='text-accent'>125%</span> oshirilgan bonus va 250 tagacha frispinlarga ega boʻling!\n",
  welcomeBonusSport: "Welcome bonusingizni sport",
  welcomeBonusTitle: "Welcome bonusiga +25%\n",
  win: "G'alaba",
  winnerPoints: "G'alaba:",
  winners: "G'olib bo'lganlar\n",
  withAnIncrease: "Ko'tarilish bilan",
  withDrawOrdered: "Xulosa rasmiylashtirildi",
  withDrawOrderedDesc: "Yaqin kelajakda mablag'lar belgilangan hisobingizga o'tkaziladi.",
  withInstantCashback: "Bir zumli keshbek bilan",
  withdraw: "chiqarish",
  withdraw2: "chiqarib olmoq",
  withdrawBK: "BCga chiqarish",
  withdrawFunds: "Olib chiqish",
  withdrawMethod: "Chiqarish usuli",
  withdrawMethods: "Chiqarish usullarii",
  withdrawNoun: "Chiqarish",
  withdrawPaymentInfo: "Visa/Mastercard orqali pul yechib olish faqat login bilan bog'langanlar uchun mavjud kartalar. Bog'lash uchun Sizga  loginni Visa/Mastercard orqali to'ldirishingiz kerak.",
  withdrawPerDayCountExceeded: "Siz har kuni 1 tagacha pul yechib olishingiz mumkin ",
  withdrawTelegramBot: "Pulni yechib olish uchun siz Telegram-botni ishga tushirishingiz va unga kirishingiz kerak",
  withdrawWithApprove: "Kodni tasdiqlash bilan pul yechib olish",
  withdrawWithCode: "Tasdiqlash kodi bilan pul mablag'larini yechib olish",
  withdrawal: "Mablag'larni olib qo'yishda cheklovlar",
  withdrawalCompletedSuccessfully: "Pulni yechib olish buyrug'i yaratildi",
  withdrawalOfFunds: "Tasdiqlash kodi bilan pul mablag'larini yechib olish",
  work: "Texnik ishlar olib borilmoqda",
  writeToSupport: "Qo'llab-quvvatlashga yozing\n",
  yes: "Ha",
  yesConfirm: "Ha, ishonchim komil",
  yesOfCourseIWant: "Ha, albatta xohlayman",
  yesRefundWithdrawal: "Ha, Pul yechib olishni bekor qiling",
  yesSure: "Ha, to'ldirildi\n",
  you: "Siz",
  youAreAuthorized: "Siz tizimga kirgansiz",
  youAreParticipateInTheTournament: "Siz turnirda ishtirok etyapsiz!",
  youDontHaveTransactions: "Sizda hali hech qanday tranzaksiya yo'q",
  youHaveNewMessage: "Sizda yangi xabar bor",
  youHaveNotNewMessages: "Sizda yangi xabar yoʻq\n",
  youHaveSmsVerification: "Sizda to'lovlarni tekshirish qo'shilgan, o'tkazmani amalga oshirish uchun SMS orqali tekshiruvdan o'ting",
  youTakePart: "Siz ishtirok etyapsiz",
  yourBalance: "Sizning balansingiz",
  yourCasinoBonus: "Sizning kazino bonusingiz",
  yourCurrentEmail: "Sizning hozirgi elektron pochtangiz",
  yourCurrentPhone: "Sizning hozirgi raqamingiz",
  yourEmail: "Sizning elektron manzilingiz",
  yourPersonalUniqueWalletIsDisplayedHere: "Bu yerda avval tanlagan tanga uchun shaxsiy noyob hamyoningiz ko'rsatiladi. Hamyon manzilini nusxalash uchun siz maxsus tugma yoki QR koddan foydalanishingiz mumkin."
} 
